webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(101);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchSections;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchArticles;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchSection;
/* harmony export (immutable) */ __webpack_exports__["d"] = moveArticleToSection;
/* harmony export (immutable) */ __webpack_exports__["i"] = positionArticle;
/* harmony export (immutable) */ __webpack_exports__["j"] = positionSection;
/* harmony export (immutable) */ __webpack_exports__["g"] = moveSectionToSection;
/* harmony export (immutable) */ __webpack_exports__["f"] = moveSectionToCategory;
/* harmony export (immutable) */ __webpack_exports__["h"] = moveSectionToTop;
/* harmony export (immutable) */ __webpack_exports__["e"] = moveArticleToTop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_positioning__ = __webpack_require__(74);







function fetchSectionsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["g" /* FETCH_SECTION_SECTIONS_REQUEST */]
  };
}

function fetchSectionsSuccess(sections, page, pageCount, count) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["h" /* FETCH_SECTION_SECTIONS_SUCCESS */],
    sections: sections,
    page: page,
    pageCount: pageCount,
    count: count
  };
}

function fetchSectionsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* FETCH_SECTION_SECTIONS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchSections(sectionId, _ref) {
  var page = _ref.page;
  return function (dispatch, getState) {
    dispatch(fetchSectionsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("/hc/api/internal/arrange_articles/sections/".concat(sectionId, "/sections?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])(), "&page=").concat(page, "&per_page=5")).then(function (_ref2) {
      var sections = _ref2.sections,
          page = _ref2.page,
          page_count = _ref2.page_count,
          count = _ref2.count;
      return dispatch(fetchSectionsSuccess(sections, page, page_count, count));
    }).catch(function (err) {
      dispatch(fetchSectionsFailure(err));
    });
  };
}

function fetchArticlesRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_SECTION_ARTICLES_REQUEST */]
  };
}

function fetchArticlesSuccess(articles, page, pageCount, count) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_SECTION_ARTICLES_SUCCESS */],
    articles: articles,
    page: page,
    pageCount: pageCount,
    count: count
  };
}

function fetchArticlesFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_SECTION_ARTICLES_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchArticles(sectionId, _ref3) {
  var page = _ref3.page;
  return function (dispatch, getState) {
    dispatch(fetchArticlesRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("/hc/api/internal/arrange_articles/sections/".concat(sectionId, "/articles?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])(), "&page=").concat(page, "&per_page=30")).then(function (_ref4) {
      var articles = _ref4.articles,
          page = _ref4.page,
          page_count = _ref4.page_count,
          count = _ref4.count;
      return dispatch(fetchArticlesSuccess(articles, page, page_count, count));
    }).catch(function (err) {
      dispatch(fetchArticlesFailure(err));
    });
  };
}

function fetchSectionRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* FETCH_SECTION_REQUEST */]
  };
}

function fetchSectionSuccess(section) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["i" /* FETCH_SECTION_SUCCESS */],
    section: section
  };
}

function fetchSectionFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["d" /* FETCH_SECTION_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchSection(id, sectionPage, articlePage) {
  return function (dispatch, getState) {
    dispatch(fetchSectionRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("/hc/api/internal/arrange_articles/sections/".concat(id, "?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])())).then(function (_ref5) {
      var section = _ref5.section;
      dispatch(fetchSections(section.id, {
        page: sectionPage
      }));
      dispatch(fetchArticles(section.id, {
        page: articlePage
      }));
      dispatch(fetchSectionSuccess(section));
    }).catch(function (err) {
      dispatch(fetchSectionFailure(err));
    });
  };
}

function moveArticleToSectionRequest(movedArticleId, destinationSectionId, sourceIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["k" /* MOVE_ARTICLE_TO_SECTION_REQUEST */],
    movedArticleId: movedArticleId,
    destinationSectionId: destinationSectionId,
    sourceIndex: sourceIndex
  };
}

function moveArticleToSectionSuccess(articleId, destinationSectionId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["l" /* MOVE_ARTICLE_TO_SECTION_SUCCESS */],
    articleId: articleId,
    destinationSectionId: destinationSectionId
  };
}

function moveArticleToSectionFailure(movedItem, destinationSectionId, sourceIndex, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["j" /* MOVE_ARTICLE_TO_SECTION_FAILURE */],
    error: true,
    payload: error,
    movedItem: movedItem,
    destinationSectionId: destinationSectionId,
    sourceIndex: sourceIndex
  };
}

function moveArticleToSection(articleId, sectionId, sourceIndex) {
  return function (dispatch, getState) {
    var _getState = getState(),
        list = _getState.articles.list;

    var movedItem = list.find(function (_ref6) {
      var id = _ref6.id;
      return articleId === id;
    });
    dispatch(moveArticleToSectionRequest(articleId, sectionId, sourceIndex)); // Replace with multibranded internal api endpoint when it's ready

    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["put"])("/hc/api/internal/arrange_articles/articles/".concat(articleId, "?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])()), {
      article: {
        section_id: sectionId
      }
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(moveArticleToSectionSuccess(articleId, sectionId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showSuccess"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.articleMoved.success")));
    }).catch(function (err) {
      dispatch(moveArticleToSectionFailure(movedItem, sectionId, sourceIndex, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.articleMoved.failure")));
    });
  };
}

function positionArticleRequest(sourceIndex, destinationIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["z" /* POSITION_ARTICLE_REQUEST */],
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionArticleSuccess(sourceIndex, destinationIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["A" /* POSITION_ARTICLE_SUCCESS */],
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionArticleFailure(sourceIndex, destinationIndex, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["y" /* POSITION_ARTICLE_FAILURE */],
    error: true,
    payload: error,
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionArticle(sectionId, articleId, sourceIndex, destinationIndex) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        list = _getState2.articles.list;

    var payload = {
      positioned_article_id: articleId
    };

    if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["d" /* isMovingDown */])(sourceIndex, destinationIndex)) {
      var item = Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["b" /* getItemAbove */])(list, sourceIndex, destinationIndex);
      payload.below_id = item && item.id;
    } else {
      var _item = Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["c" /* getItemBelow */])(list, sourceIndex, destinationIndex);

      payload.above_id = _item && _item.id;
    }

    dispatch(positionArticleRequest(sourceIndex, destinationIndex));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["post"])("/hc/api/internal/arrange_articles/sections/".concat(sectionId, "/position_article?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])()), payload, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(positionArticleSuccess(sourceIndex, destinationIndex));
    }).catch(function (err) {
      dispatch(positionArticleFailure(sourceIndex, destinationIndex, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.articlePositioned.failure")));
    });
  };
}

function positionSectionRequest(sourceIndex, destinationIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["C" /* POSITION_SECTION_REQUEST */],
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionSectionSuccess(sourceIndex, destinationIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["D" /* POSITION_SECTION_SUCCESS */],
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionSectionFailure(sourceIndex, destinationIndex, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["B" /* POSITION_SECTION_FAILURE */],
    error: true,
    payload: error,
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionSection(sectionId, positionedSectionId, sourceIndex, destinationIndex) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        list = _getState3.sections.list;

    var payload = {
      positioned_section_id: positionedSectionId
    };

    if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["d" /* isMovingDown */])(sourceIndex, destinationIndex)) {
      var item = Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["b" /* getItemAbove */])(list, sourceIndex, destinationIndex);
      payload.below_id = item && item.id;
    } else {
      var _item2 = Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["c" /* getItemBelow */])(list, sourceIndex, destinationIndex);

      payload.above_id = _item2 && _item2.id;
    }

    dispatch(positionSectionRequest(sourceIndex, destinationIndex));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["post"])("/hc/api/internal/arrange_articles/sections/".concat(sectionId, "/position_section?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])()), payload, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(positionSectionSuccess(sourceIndex, destinationIndex));
    }).catch(function (err) {
      dispatch(positionSectionFailure(sourceIndex, destinationIndex, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.sectionPositioned.failure")));
    });
  };
}

function moveSectionToSectionRequest(movedSectionId, destinationSectionId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["t" /* MOVE_SECTION_TO_SECTION_REQUEST */],
    movedSectionId: movedSectionId,
    destinationSectionId: destinationSectionId
  };
}

function moveSectionToSectionSuccess(destinationSectionId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["u" /* MOVE_SECTION_TO_SECTION_SUCCESS */],
    destinationSectionId: destinationSectionId
  };
}

function moveSectionToSectionFailure(item, destinationSectionId, sourceIndex, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["s" /* MOVE_SECTION_TO_SECTION_FAILURE */],
    error: true,
    payload: error,
    item: item,
    sourceIndex: sourceIndex,
    destinationSectionId: destinationSectionId
  };
}

function moveSectionToSection(movedSectionId, destinationSectionId, sourceIndex) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        list = _getState4.sections.list;

    var movedItem = list.find(function (_ref7) {
      var id = _ref7.id;
      return movedSectionId === id;
    });
    dispatch(moveSectionToSectionRequest(movedSectionId, destinationSectionId));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["put"])("/hc/api/internal/arrange_articles/sections/".concat(movedSectionId, "?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])()), {
      section: {
        parent_section_id: destinationSectionId
      }
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(moveSectionToSectionSuccess(destinationSectionId));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showSuccess"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.sectionMoved.success")));
    }).catch(function (err) {
      dispatch(moveSectionToSectionFailure(movedItem, destinationSectionId, sourceIndex, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.sectionMoved.failure")));
    });
  };
}

function moveSectionToCategoryRequest(movedSectionId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["q" /* MOVE_SECTION_TO_CATEGORY_REQUEST */],
    movedSectionId: movedSectionId
  };
}

function moveSectionToCategorySuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["r" /* MOVE_SECTION_TO_CATEGORY_SUCCESS */]
  };
}

function moveSectionToCategoryFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["p" /* MOVE_SECTION_TO_CATEGORY_FAILURE */],
    error: true,
    payload: error
  };
}

function moveSectionToCategory(movedSectionId, destinationCategoryId, sourceIndex) {
  return function (dispatch, getState) {
    dispatch(moveSectionToCategoryRequest(movedSectionId));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["put"])("/hc/api/internal/arrange_articles/sections/".concat(movedSectionId, "?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])()), {
      section: {
        category_id: destinationCategoryId
      }
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(moveSectionToCategorySuccess());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showSuccess"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.sectionMoved.success")));
    }).catch(function (err) {
      dispatch(moveSectionToCategoryFailure(err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.sectionMoved.failure")));
    });
  };
}

function moveSectionToTopRequest(sourceIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["w" /* MOVE_SECTION_TO_TOP_REQUEST */],
    sourceIndex: sourceIndex
  };
}

function moveSectionToTopSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["x" /* MOVE_SECTION_TO_TOP_SUCCESS */]
  };
}

function moveSectionToTopFailure(sourceIndex, item, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["v" /* MOVE_SECTION_TO_TOP_FAILURE */],
    error: true,
    payload: error,
    sourceIndex: sourceIndex,
    item: item
  };
}

function moveSectionToTop(movedSection, sourceIndex) {
  return function (dispatch, getState) {
    var _getState5 = getState(),
        section = _getState5.section;

    dispatch(moveSectionToTopRequest(sourceIndex));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["post"])("/hc/api/internal/arrange_articles/sections/".concat(section.id, "/position_section?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])()), {
      positioned_section_id: movedSection.id,
      below_id: null
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(moveSectionToTopSuccess());
    }).catch(function (err) {
      dispatch(moveSectionToTopFailure(sourceIndex, movedSection, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.sectionPositioned.failure")));
    });
  };
}

function moveArticleToTopRequest(sourceIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["n" /* MOVE_ARTICLE_TO_TOP_REQUEST */],
    sourceIndex: sourceIndex
  };
}

function moveArticleToTopSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["o" /* MOVE_ARTICLE_TO_TOP_SUCCESS */]
  };
}

function moveArticleToTopFailure(sourceIndex, item, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["m" /* MOVE_ARTICLE_TO_TOP_FAILURE */],
    error: true,
    payload: error,
    sourceIndex: sourceIndex,
    item: item
  };
}

function moveArticleToTop(movedArticle, sourceIndex) {
  return function (dispatch, getState) {
    var _getState6 = getState(),
        section = _getState6.section;

    dispatch(moveArticleToTopRequest(sourceIndex));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["post"])("/hc/api/internal/arrange_articles/sections/".concat(section.id, "/position_article?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCurrentBrandId"])()), {
      positioned_article_id: movedArticle.id,
      below_id: null
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(moveArticleToTopSuccess());
    }).catch(function (err) {
      dispatch(moveArticleToTopFailure(sourceIndex, movedArticle, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_3__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.articlePositioned.failure")));
    });
  };
}

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resilient__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_resilient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_resilient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ErrorScreen__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_notifyError__ = __webpack_require__(245);







var reportError = function reportError(error) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__utils_notifyError__["a" /* default */])("ErrorBoundary", error);
};

var ErrorBoundary = function ErrorBoundary(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_3_react_resilient___default.a, {
    FallbackComponent: __WEBPACK_IMPORTED_MODULE_4__ErrorScreen__["a" /* default */],
    onError: reportError
  }, void 0, children);
};

ErrorBoundary.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Empty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);




function Empty(_ref) {
  var children = _ref.children,
      testId = _ref.testId;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.empty,
    "data-test-id": testId
  }, void 0, children);
}

Empty.Title = function EmptyTitle(_ref2) {
  var children = _ref2.children;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.title
  }, void 0, children);
};

Empty.Description = function Description(_ref3) {
  var children = _ref3.children;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.description
  }, void 0, children);
};

Empty.Actions = function EmptyActions(_ref4) {
  var children = _ref4.children;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__index_css___default.a.actions
  }, void 0, children);
};

Empty.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  testId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
Empty.Title.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
Empty.Description.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
Empty.Actions.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_loaders__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__index_css__);











var LOADING_OVERLAY_DELAY = 1000; // ms

var DelayedComponent =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DelayedComponent, _Component);

  function DelayedComponent(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DelayedComponent);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DelayedComponent).call(this, props));
    _this.state = {
      visible: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DelayedComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var delay = this.props.delay;
      this.timeoutId = setTimeout(function () {
        _this2.setState({
          visible: true
        });
      }, delay);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: "render",
    value: function render() {
      var visible = this.state.visible;
      var children = this.props.children;

      if (!visible) {
        return null;
      }

      return children;
    }
  }]);

  return DelayedComponent;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

DelayedComponent.propTypes = {
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types__["PropTypes"].number,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types__["PropTypes"].node
};

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__zendeskgarden_react_loaders__["Spinner"], {
  delayMS: 0
});

function LoadingOverlay(_ref) {
  var loading = _ref.loading;

  if (!loading) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(DelayedComponent, {
    delay: LOADING_OVERLAY_DELAY
  }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__index_css___default.a.loadingOverlay
  }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__index_css___default.a.loaderWrapper
  }, void 0, _ref2)));
}

LoadingOverlay.propTypes = {
  loading: __WEBPACK_IMPORTED_MODULE_7_prop_types__["PropTypes"].bool
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var categories = _ref3.categories,
      category = _ref3.category,
      sections = _ref3.sections,
      section = _ref3.section,
      articles = _ref3.articles;
  return {
    loading: categories.isFetching || category.isFetching || sections.isFetching || section.isFetching || articles.isFetching
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(mapStateToProps)(LoadingOverlay));

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_redux_lib_connectors_connectNotifications__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_redux_lib_connectors_connectNotifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_redux_lib_connectors_connectNotifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_components_lib_Notifications__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_components_lib_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_components_lib_Notifications__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_redux_lib_connectors_connectNotifications___default()(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_components_lib_Notifications___default.a));

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_CATEGORY_SECTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_CATEGORY_SECTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CATEGORY_SECTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return POSITION_CATEGORY_SECTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return POSITION_CATEGORY_SECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return POSITION_CATEGORY_SECTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MOVE_CATEGORY_SECTION_TO_TOP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MOVE_CATEGORY_SECTION_TO_TOP_FAILURE; });
var FETCH_CATEGORY_REQUEST = "FETCH_CATEGORY_REQUEST";
var FETCH_CATEGORY_SUCCESS = "FETCH_CATEGORY_SUCCESS";
var FETCH_CATEGORY_FAILURE = "FETCH_CATEGORY_FAILURE";
var FETCH_CATEGORY_SECTIONS_REQUEST = "FETCH_CATEGORY_SECTIONS_REQUEST";
var FETCH_CATEGORY_SECTIONS_SUCCESS = "FETCH_CATEGORY_SECTIONS_SUCCESS";
var FETCH_CATEGORY_SECTIONS_FAILURE = "FETCH_CATEGORY_SECTIONS_FAILURE";
var POSITION_CATEGORY_SECTION_REQUEST = "POSITION_CATEGORY_SECTION_REQUEST";
var POSITION_CATEGORY_SECTION_SUCCESS = "POSITION_CATEGORY_SECTION_SUCCESS";
var POSITION_CATEGORY_SECTION_FAILURE = "POSITION_CATEGORY_SECTION_FAILURE";
var MOVE_CATEGORY_SECTION_TO_TOP_REQUEST = "MOVE_CATEGORY_SECTION_TO_TOP_REQUEST";
var MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS = "MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS";
var MOVE_CATEGORY_SECTION_TO_TOP_FAILURE = "MOVE_CATEGORY_SECTION_TO_TOP_FAILURE";

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(101);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(184)('keys')
  , uid    = __webpack_require__(130);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(51)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(181);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports = true;

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(100)
  , dPs         = __webpack_require__(686)
  , enumBugKeys = __webpack_require__(185)
  , IE_PROTO    = __webpack_require__(183)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(274)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(687).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(77).f
  , has = __webpack_require__(63)
  , TAG = __webpack_require__(81)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(81);

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(51)
  , core           = __webpack_require__(52)
  , LIBRARY        = __webpack_require__(188)
  , wksExt         = __webpack_require__(192)
  , defineProperty = __webpack_require__(77).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler__);

var errorHandler = new __WEBPACK_IMPORTED_MODULE_0__zendesk_knowledge_utils_lib_ErrorHandler___default.a();

var notifyError = function notifyError(component, error) {
  errorHandler.notify({
    error: error,
    context: {
      version: "no version provided",
      component: "arrange:".concat(component),
      details: error.details
    }
  });
  console.error(component, error);
};

/* harmony default export */ __webpack_exports__["a"] = (notifyError);

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CATEGORIES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CATEGORIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CATEGORIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return POSITION_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return POSITION_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return POSITION_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MOVE_CATEGORY_TO_TOP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MOVE_CATEGORY_TO_TOP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MOVE_CATEGORY_TO_TOP_FAILURE; });
var FETCH_CATEGORIES_REQUEST = "FETCH_CATEGORIES_REQUEST";
var FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
var FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";
var POSITION_CATEGORY_REQUEST = "POSITION_CATEGORY_REQUEST";
var POSITION_CATEGORY_SUCCESS = "POSITION_CATEGORY_SUCCESS";
var POSITION_CATEGORY_FAILURE = "POSITION_CATEGORY_FAILURE";
var MOVE_CATEGORY_TO_TOP_REQUEST = "MOVE_CATEGORY_TO_TOP_REQUEST";
var MOVE_CATEGORY_TO_TOP_SUCCESS = "MOVE_CATEGORY_TO_TOP_SUCCESS";
var MOVE_CATEGORY_TO_TOP_FAILURE = "MOVE_CATEGORY_TO_TOP_FAILURE";

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SectionList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_connected_react_router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_pagination__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_section__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SectionRow__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__index_css__);




















var SectionList =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(SectionList, _Component);

  function SectionList(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, SectionList);

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(SectionList).call(this, props));
    _this.onSectionClicked = _this.onSectionClicked.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onSectionMoveTo = _this.onSectionMoveTo.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(SectionList, [{
    key: "onSectionClicked",
    value: function onSectionClicked(sectionId) {
      var dispatch = this.props.dispatch;
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_connected_react_router__["push"])({
        pathname: "/knowledge/arrange/sections/".concat(sectionId),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }
  }, {
    key: "onSectionMoveTo",
    value: function onSectionMoveTo(sectionId, destinationOption, sourceIndex) {
      var dispatch = this.props.dispatch;
      var destinationOptionId = destinationOption.id,
          destinationOptionType = destinationOption.type;
      destinationOptionType === "Section" ? dispatch(__WEBPACK_IMPORTED_MODULE_17__actions_section__["g" /* moveSectionToSection */](sectionId, destinationOptionId, sourceIndex)) : dispatch(__WEBPACK_IMPORTED_MODULE_17__actions_section__["f" /* moveSectionToCategory */](sectionId, destinationOptionId, sourceIndex));
    }
  }, {
    key: "renderSections",
    value: function renderSections() {
      var _this2 = this;

      var _this$props = this.props,
          sections = _this$props.sections,
          isFetching = _this$props.isFetching,
          pageCount = _this$props.pageCount,
          page = _this$props.page,
          onPageSelected = _this$props.onPageSelected,
          count = _this$props.count,
          isMoving = _this$props.isMoving,
          sectionSavingId = _this$props.sectionSavingId,
          sectionSuccessId = _this$props.sectionSuccessId,
          _onMoveToTop = _this$props.onMoveToTop;

      if (isFetching) {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
          className: __WEBPACK_IMPORTED_MODULE_19__index_css___default.a.loader,
          style: {
            height: "".concat(Math.min(count, 5) * 73, "px")
          }
        });
      }

      var pagination = pageCount > 1 && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
        "data-test-id": "sections-pagination"
      }, void 0, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_pagination__["Pagination"], {
        totalPages: pageCount,
        currentPage: page,
        onChange: onPageSelected
      }));

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {}, void 0, sections.map(function (section, index) {
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["b" /* Draggable */], {
          isCombineEnabled: true,
          type: "section",
          draggableId: section.id,
          index: index,
          isDragDisabled: isMoving
        }, section.id, function (providedDraggable, snapshotDraggable) {
          return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["c" /* Droppable */], {
            droppableId: "section-".concat(section.id),
            type: "article"
          }, void 0, function (providedDroppable, snapshotDroppable) {
            return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
              className: __WEBPACK_IMPORTED_MODULE_19__index_css___default.a.draggable,
              ref: providedDraggable.innerRef
            }, providedDraggable.draggableProps, {
              style: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, providedDraggable.draggableProps.style, {
                opacity: 1
              })
            }), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
              ref: providedDroppable.innerRef
            }, providedDroppable.droppableProps), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__SectionRow__["a" /* default */], {
              onClick: function onClick() {
                return _this2.onSectionClicked(section.id);
              },
              onMoveToTop: function onMoveToTop() {
                return _onMoveToTop(section, index);
              },
              testId: "section-item",
              section: section,
              saving: sectionSavingId === section.id,
              success: sectionSuccessId === section.id,
              highlight: snapshotDroppable.isDraggingOver || snapshotDraggable.combineTargetFor !== null,
              dragHandleProps: providedDraggable.dragHandleProps,
              onMoveTo: function onMoveTo(destinationOption) {
                return _this2.onSectionMoveTo(section.id, destinationOption, index);
              }
            }, section.id)));
          });
        });
      })), pagination);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var count = this.props.count;

      if (count === 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_19__index_css___default.a.container
      }, void 0, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()("h3", {
        className: __WEBPACK_IMPORTED_MODULE_19__index_css___default.a.listHeader
      }, void 0, __WEBPACK_IMPORTED_MODULE_13__zendesk_client_i18n_tools___default()("knowledge-arrange.sections.pageTitle", {
        count: count
      })), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["c" /* Droppable */], {
        droppableId: "sections",
        type: "section",
        isCombineEnabled: true
      }, void 0, function (provided, snapshot) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          ref: provided.innerRef
        }, provided.droppableProps), _this3.renderSections());
      }));
    }
  }]);

  return SectionList;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);
SectionList.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  sections: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    edit_url: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    html_url: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    section_count: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired,
    article_count: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired
  })).isRequired,
  count: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired,
  isFetching: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool.isRequired,
  pageCount: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired,
  page: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired,
  onPageSelected: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  onMoveToTop: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  sectionSavingId: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number,
  sectionSuccessId: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number,
  isMoving: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool
};

var mapStateToProps = function mapStateToProps(_ref) {
  var sections = _ref.sections;
  return {
    sections: sections.list,
    isFetching: sections.isFetching,
    pageCount: sections.pageCount,
    sectionSavingId: sections.savingId,
    sectionSuccessId: sections.successId,
    isMoving: sections.isMoving
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["connect"])(mapStateToProps)(SectionList));

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoveToModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_PlacementSelector__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_PlacementSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_PlacementSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_modals__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_modals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_modals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Gap__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Gap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Gap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_buttons__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);

















var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_components_lib_Gap___default.a.Medium, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_modals__["Close"], {
  "aria-label": "Close modal"
});

var MoveToModal =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(MoveToModal, _Component);

  function MoveToModal(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, MoveToModal);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(MoveToModal).call(this, props));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)), "onSectionClick", function (option) {
      _this.setState({
        selectedOption: option
      });
    });

    _this.state = {
      selectedOption: {
        type: undefined,
        id: null
      }
    };
    _this.onOptionSelect = _this.onOptionSelect.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(MoveToModal, [{
    key: "onOptionSelect",
    value: function onOptionSelect() {
      var onMove = this.props.onMove;
      var selectedOption = this.state.selectedOption;
      onMove(selectedOption);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClose = _this$props.onClose,
          _name = _this$props.name,
          destinationTypes = _this$props.destinationTypes;
      var selectedOption = this.state.selectedOption;
      var isButtonDisabled = !selectedOption.id || !destinationTypes.includes(selectedOption.type);
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_modals__["Modal"], {
        onClose: onClose
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_modals__["Header"], {}, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-arrange.moveTo_move")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_modals__["Body"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.body
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("p", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.description
      }, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default.a.format("knowledge-arrange.moveTo.selectDestination", {
        name: function name() {
          return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("strong", {
            className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.name
          }, "item-name", "\"".concat(_name, "\""));
        }
      })), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__zendesk_knowledge_components_lib_PlacementSelector___default.a, {
        onOptionSelect: this.onSectionClick
      }))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_modals__["Footer"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_buttons__["Button"], {
        onClick: onClose
      }, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-arrange.moveTo_cancel")), _ref, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__zendeskgarden_react_buttons__["Button"], {
        primary: true,
        disabled: isButtonDisabled,
        onClick: this.onOptionSelect
      }, void 0, __WEBPACK_IMPORTED_MODULE_12__zendesk_client_i18n_tools___default()("knowledge-arrange.moveTo_move"))), _ref2);
    }
  }]);

  return MoveToModal;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);


MoveToModal.propTypes = {
  onClose: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func.isRequired,
  onMove: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string,
  destinationTypes: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].array.isRequired
};

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(673);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(78) && !__webpack_require__(79)(function(){
  return Object.defineProperty(__webpack_require__(274)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(101)
  , document = __webpack_require__(51).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(63)
  , toIObject    = __webpack_require__(64)
  , arrayIndexOf = __webpack_require__(675)(false)
  , IE_PROTO     = __webpack_require__(183)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(277);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(681);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(693);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(188)
  , $export        = __webpack_require__(75)
  , redefine       = __webpack_require__(280)
  , hide           = __webpack_require__(76)
  , has            = __webpack_require__(63)
  , Iterators      = __webpack_require__(189)
  , $iterCreate    = __webpack_require__(685)
  , setToStringTag = __webpack_require__(191)
  , getPrototypeOf = __webpack_require__(688)
  , ITERATOR       = __webpack_require__(81)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(76);

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(275)
  , hiddenKeys = __webpack_require__(185).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(131)
  , createDesc     = __webpack_require__(129)
  , toIObject      = __webpack_require__(64)
  , toPrimitive    = __webpack_require__(180)
  , has            = __webpack_require__(63)
  , IE8_DOM_DEFINE = __webpack_require__(273)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(78) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pathForBreadcrumb;
function pathForBreadcrumb(item) {
  if (item.type === "Brand") {
    return "/knowledge/arrange";
  }

  return "/knowledge/arrange/".concat(item.type === "Section" ? "sections" : "categories", "/").concat(item.id);
}

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(291);
module.exports = __webpack_require__(292);


/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_polyfill__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendeskgarden_react_tags_dist_styles_css__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendeskgarden_react_tags_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zendeskgarden_react_tags_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendeskgarden_react_buttons_dist_styles_css__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zendeskgarden_react_buttons_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__zendeskgarden_react_buttons_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zendeskgarden_react_pagination_dist_styles_css__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__zendeskgarden_react_pagination_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__zendeskgarden_react_pagination_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendeskgarden_react_menus_dist_styles_css__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendeskgarden_react_menus_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendeskgarden_react_menus_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendeskgarden_react_modals_dist_styles_css__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zendeskgarden_react_modals_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__zendeskgarden_react_modals_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_thunk__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_connected_react_router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_redux_lib_middleware_logMiddleware__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_redux_lib_middleware_logMiddleware___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_redux_lib_middleware_logMiddleware__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_redux_lib_middleware_notificationMiddleware__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_redux_lib_middleware_notificationMiddleware___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_redux_lib_middleware_notificationMiddleware__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_notifyError__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_PageNavigator_getQuery__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_PageNavigator_getQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_PageNavigator_getQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_PageNavigator_setQuery__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_PageNavigator_setQuery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_PageNavigator_setQuery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_createBrowserHistory__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__zendesk_knowledge_analytics__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__zendesk_knowledge_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__zendesk_knowledge_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__zendesk_knowledge_connect__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__zendesk_knowledge_connect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__zendesk_knowledge_connect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_App__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__reducers__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__zendesk_knowledge_context__);



























var history = __WEBPACK_IMPORTED_MODULE_20_history_createBrowserHistory___default()();
var middleware = [Object(__WEBPACK_IMPORTED_MODULE_14_connected_react_router__["routerMiddleware"])(history), __WEBPACK_IMPORTED_MODULE_12_redux_thunk___default.a, __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_redux_lib_middleware_logMiddleware___default()(__WEBPACK_IMPORTED_MODULE_17__utils_notifyError__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_redux_lib_middleware_notificationMiddleware___default.a];

if (false) {
  var _require = require("redux-logger"),
      createLogger = _require.createLogger;

  var logger = createLogger({
    collapsed: true
  });
  middleware.push(logger);
}

var enhancer = __WEBPACK_IMPORTED_MODULE_13_redux__["a" /* applyMiddleware */].apply(void 0, middleware);
var store = Object(__WEBPACK_IMPORTED_MODULE_13_redux__["d" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_25__reducers__["a" /* default */])(history), undefined, enhancer);

var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_redux__["Provider"], {
  store: store
}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14_connected_react_router__["ConnectedRouter"], {
  history: history
}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__components_App__["a" /* default */], {})));

function renderApp(context) {
  __WEBPACK_IMPORTED_MODULE_21__zendesk_client_i18n_tools___default.a.load(context.token.user.locale, function () {
    document.title = __WEBPACK_IMPORTED_MODULE_21__zendesk_client_i18n_tools___default()("knowledge-arrange.name");
    Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["render"])(_ref, document.getElementById("container"));
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_22__zendesk_knowledge_analytics___default.a.setup();
      __WEBPACK_IMPORTED_MODULE_23__zendesk_knowledge_connect___default.a.setup();
    }, 1000);
  });
}

var query = __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_PageNavigator_getQuery___default()(); // Make sure a brand with a help center is selected.
// If brand_id in the query is not valid or is not set
// pick the agent brand or a first suitable brand

Object(__WEBPACK_IMPORTED_MODULE_26__zendesk_knowledge_context__["loadContext"])({
  brandId: query.brand_id
}).then(function (context) {
  if (!(Object(__WEBPACK_IMPORTED_MODULE_26__zendesk_knowledge_context__["hasEntitlement"])("admin") || Object(__WEBPACK_IMPORTED_MODULE_26__zendesk_knowledge_context__["hasEntitlement"])("manager")) || !Object(__WEBPACK_IMPORTED_MODULE_26__zendesk_knowledge_context__["hasFeature"])("guide_arrange_articles")) {
    window.location.replace("/knowledge/lists");
    return;
  }

  var hasBrandId = "brand_id" in query;

  if (!hasBrandId) {
    __WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_PageNavigator_setQuery___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({}, query, {
      brand_id: context.default_brand.id
    }));
  }

  renderApp(context);
});

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export App */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryList__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Category__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Section__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(739);












var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["b" /* Switch */], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Route */], {
  exact: true,
  path: "/knowledge/arrange",
  component: __WEBPACK_IMPORTED_MODULE_7__CategoryList__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Route */], {
  exact: true,
  path: "/knowledge/arrange/categories",
  component: __WEBPACK_IMPORTED_MODULE_7__CategoryList__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Route */], {
  exact: true,
  path: "/knowledge/arrange/categories/page/:page",
  component: __WEBPACK_IMPORTED_MODULE_7__CategoryList__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Route */], {
  exact: true,
  path: "/knowledge/arrange/categories/:id",
  component: __WEBPACK_IMPORTED_MODULE_8__Category__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Route */], {
  exact: true,
  path: "/knowledge/arrange/categories/:id/page/:page",
  component: __WEBPACK_IMPORTED_MODULE_8__Category__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Route */], {
  exact: true,
  path: "/knowledge/arrange/sections/:id",
  component: __WEBPACK_IMPORTED_MODULE_9__Section__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* Route */], {
  exact: true,
  path: "/knowledge/arrange/sections/:id/section_page/:sectionPage/article_page/:articlePage",
  component: __WEBPACK_IMPORTED_MODULE_9__Section__["a" /* default */]
}));

var App =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(App, _Component);

  function App() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, App);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(App).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(App, [{
    key: "render",
    value: function render() {
      return _ref;
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["c" /* withRouter */])(App));

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CategoryList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_connected_react_router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_pagination__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_beautiful_dnd__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_createBrandedUrl__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_createBrandedUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_createBrandedUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_categories__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ErrorBoundary__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CategoryRow__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Empty__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__LoadingOverlay__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Notifications__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_css__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__index_css__);




























var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__LoadingOverlay__["a" /* default */], {});

var CategoryList =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(CategoryList, _Component);

  function CategoryList(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, CategoryList);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(CategoryList).call(this, props));
    _this.onPageSelected = _this.onPageSelected.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onCategoryClicked = _this.onCategoryClicked.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onDragEnd = _this.onDragEnd.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onMoveToTop = _this.onMoveToTop.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(CategoryList, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          dispatch = _this$props.dispatch,
          page = _this$props.page;
      dispatch(__WEBPACK_IMPORTED_MODULE_20__actions_categories__["a" /* fetchCategories */]({
        page: page
      }));
    }
  }, {
    key: "openNewCategoryPage",
    value: function openNewCategoryPage() {
      var hc = Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getHelpCenter"])();
      window.open(__WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_createBrandedUrl___default()(hc.route.subdomain, "/hc/admin/categories/new"), "_blank");
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      var dispatch = this.props.dispatch;
      dispatch(__WEBPACK_IMPORTED_MODULE_20__actions_categories__["a" /* fetchCategories */]({
        page: page
      }));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_connected_react_router__["push"])({
        pathname: "/knowledge/arrange/categories/page/".concat(page),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }
  }, {
    key: "onCategoryClicked",
    value: function onCategoryClicked(categoryId) {
      var dispatch = this.props.dispatch;
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_connected_react_router__["push"])({
        pathname: "/knowledge/arrange/categories/".concat(categoryId),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }
  }, {
    key: "onMoveToTop",
    value: function onMoveToTop(category, sourceIndex) {
      var dispatch = this.props.dispatch;
      dispatch(__WEBPACK_IMPORTED_MODULE_20__actions_categories__["b" /* moveCategoryToTop */](category, sourceIndex));
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(dragEnd) {
      var source = dragEnd.source,
          destination = dragEnd.destination,
          type = dragEnd.type,
          draggableId = dragEnd.draggableId;
      var dispatch = this.props.dispatch;

      if (!destination || source.droppableId === destination.droppableId && source.index === destination.index) {
        return;
      }

      if (type === "category" && destination.droppableId === "categories") {
        dispatch(__WEBPACK_IMPORTED_MODULE_20__actions_categories__["c" /* positionCategory */](draggableId, source.index, destination.index));
      }
    }
  }, {
    key: "renderCategories",
    value: function renderCategories() {
      var _this2 = this;

      var _this$props2 = this.props,
          categories = _this$props2.categories,
          categorySavingId = _this$props2.categorySavingId,
          categorySuccessId = _this$props2.categorySuccessId,
          isMoving = _this$props2.isMoving;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, categories.map(function (category, index) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18_react_beautiful_dnd__["b" /* Draggable */], {
          type: "category",
          draggableId: category.id,
          index: index,
          isDragDisabled: isMoving
        }, category.id, function (providedDraggable, snapshotDraggable) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
            className: __WEBPACK_IMPORTED_MODULE_26__index_css___default.a.draggable,
            ref: providedDraggable.innerRef
          }, providedDraggable.draggableProps), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_22__CategoryRow__["a" /* default */], {
            testId: "category-item",
            category: category,
            onClick: function onClick() {
              return _this2.onCategoryClicked(category.id);
            },
            onMoveToTop: function onMoveToTop() {
              return _this2.onMoveToTop(category, index);
            },
            saving: categorySavingId === category.id,
            success: categorySuccessId === category.id,
            dragHandleProps: providedDraggable.dragHandleProps
          }, category.id));
        });
      }));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this3 = this;

      var _this$props3 = this.props,
          count = _this$props3.count,
          isFetching = _this$props3.isFetching,
          pageCount = _this$props3.pageCount,
          page = _this$props3.page;

      if (isFetching) {
        return null;
      }

      if (count === 0) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_23__Empty__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_23__Empty__["a" /* default */].Title, {}, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.categories.empty")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_23__Empty__["a" /* default */].Description, {}, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.categories.emptyDescription")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_23__Empty__["a" /* default */].Actions, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__zendeskgarden_react_buttons__["Button"], {
          primary: true,
          size: "small",
          "data-test-id": "empty-add-category",
          onClick: this.openNewCategoryPage
        }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.categories.addCategory"))));
      }

      var pagination = pageCount > 1 && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendeskgarden_react_pagination__["Pagination"], {
        totalPages: pageCount,
        currentPage: page,
        onChange: this.onPageSelected
      });

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h3", {
        className: __WEBPACK_IMPORTED_MODULE_26__index_css___default.a.listHeader
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.categories.pageTitle", {
        count: count
      })), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18_react_beautiful_dnd__["c" /* Droppable */], {
        droppableId: "categories",
        type: "category"
      }, void 0, function (provided, snapshot) {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          ref: provided.innerRef
        }, provided.droppableProps), _this3.renderCategories());
      }), pagination);
    }
  }, {
    key: "render",
    value: function render() {
      var hasCommunity = this.props.hasCommunity;
      var hc = Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getHelpCenter"])();
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        brandId: Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])(),
        dir: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default.a.dir,
        topNav: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("a", {
          href: "/knowledge/arrange?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])())
        }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.breadcrumbs.arrangeContent"))), _ref, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.name")))
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"].Item, {
        active: true,
        testId: "sidebar-user-segments-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.name")), hasCommunity && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: __WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_createBrandedUrl___default()(hc.route.subdomain, "/hc/admin/arrange_contents#community"),
        testId: "sidebar-arrange-topics-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.sidebar.arrangeTopics")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: __WEBPACK_IMPORTED_MODULE_19__zendesk_knowledge_utils_lib_createBrandedUrl___default()(hc.route.subdomain, "/hc/admin/import_articles"),
        testId: "sidebar-import-articles-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.sidebar.importArticles"))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["ContentView"], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_21__ErrorBoundary__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_25__Notifications__["a" /* default */], {
        dir: __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default.a.dir
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_26__index_css___default.a.appHeader
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h1", {
        className: __WEBPACK_IMPORTED_MODULE_26__index_css___default.a.title
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.name"))), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18_react_beautiful_dnd__["a" /* DragDropContext */], {
        onDragEnd: this.onDragEnd
      }, void 0, this.renderContent()), _ref2)));
    }
  }]);

  return CategoryList;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
CategoryList.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  categories: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired
  })),
  isFetching: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool.isRequired,
  count: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  page: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  pageCount: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  categorySavingId: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number,
  categorySuccessId: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number,
  isMoving: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool,
  hasCommunity: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool
};

var mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var categories = _ref3.categories;
  var match = _ref4.match;
  var page = parseInt(match.params.page, 10);
  return {
    categories: categories.list,
    isFetching: categories.isFetching,
    pageCount: categories.pageCount,
    count: categories.count,
    page: isNaN(page) ? 1 : page,
    categorySavingId: categories.savingId,
    categorySuccessId: categories.successId,
    isMoving: categories.isMoving,
    hasCommunity: Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["hasFeature"])("community") && Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getHelpCenter"])().community
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(mapStateToProps)(CategoryList));

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCategories;
/* harmony export (immutable) */ __webpack_exports__["c"] = positionCategory;
/* harmony export (immutable) */ __webpack_exports__["b"] = moveCategoryToTop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_positioning__ = __webpack_require__(74);







function fetchCategoriesRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_CATEGORIES_REQUEST */]
  };
}

function fetchCategoriesSuccess(categories, page, pageCount, count) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_CATEGORIES_SUCCESS */],
    categories: categories,
    page: page,
    pageCount: pageCount,
    count: count
  };
}

function fetchCategoriesFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_CATEGORIES_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchCategories(_ref) {
  var page = _ref.page;
  return function (dispatch, getState) {
    dispatch(fetchCategoriesRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("/hc/api/internal/arrange_articles/categories?multibrand=true&brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCurrentBrandId"])(), "&page=").concat(page, "&per_page=30")).then(function (_ref2) {
      var categories = _ref2.categories,
          page = _ref2.page,
          page_count = _ref2.page_count,
          count = _ref2.count;
      return dispatch(fetchCategoriesSuccess(categories, page, page_count, count));
    }).catch(function (err) {
      dispatch(fetchCategoriesFailure(err));
    });
  };
}

function positionCategoryRequest(sourceIndex, destinationIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["h" /* POSITION_CATEGORY_REQUEST */],
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionCategorySuccess(sourceIndex, destinationIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["i" /* POSITION_CATEGORY_SUCCESS */],
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionCategoryFailure(sourceIndex, destinationIndex, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["g" /* POSITION_CATEGORY_FAILURE */],
    error: true,
    payload: error,
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionCategory(positionedCategoryId, sourceIndex, destinationIndex) {
  return function (dispatch, getState) {
    var _getState = getState(),
        list = _getState.categories.list;

    var payload = {
      positioned_category_id: positionedCategoryId
    };

    if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["d" /* isMovingDown */])(sourceIndex, destinationIndex)) {
      var item = Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["b" /* getItemAbove */])(list, sourceIndex, destinationIndex);
      payload.below_id = item && item.id;
    } else {
      var _item = Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["c" /* getItemBelow */])(list, sourceIndex, destinationIndex);

      payload.above_id = _item && _item.id;
    }

    dispatch(positionCategoryRequest(sourceIndex, destinationIndex));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["post"])("/hc/api/internal/arrange_articles/categories/".concat(positionedCategoryId, "/position_category?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCurrentBrandId"])()), payload, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(positionCategorySuccess(sourceIndex, destinationIndex));
    }).catch(function (err) {
      dispatch(positionCategoryFailure(sourceIndex, destinationIndex, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.categoryPositioned.failure")));
    });
  };
}

function moveCategoryToTopRequest(sourceIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* MOVE_CATEGORY_TO_TOP_REQUEST */],
    sourceIndex: sourceIndex
  };
}

function moveCategoryToTopSuccess() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* MOVE_CATEGORY_TO_TOP_SUCCESS */]
  };
}

function moveCategoryToTopFailure(sourceIndex, item, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["d" /* MOVE_CATEGORY_TO_TOP_FAILURE */],
    error: true,
    payload: error,
    sourceIndex: sourceIndex,
    item: item
  };
}

function moveCategoryToTop(movedCategory, sourceIndex) {
  return function (dispatch, getState) {
    dispatch(moveCategoryToTopRequest(sourceIndex));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["post"])("/hc/api/internal/arrange_articles/categories/".concat(movedCategory.id, "/position_category?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCurrentBrandId"])()), {
      positioned_category_id: movedCategory.id,
      below_id: null
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(moveCategoryToTopSuccess());
    }).catch(function (err) {
      dispatch(moveCategoryToTopFailure(sourceIndex, movedCategory, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.categoryPositioned.failure")));
    });
  };
}

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_css__);










var ErrorScreen =
/*#__PURE__*/
function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ErrorScreen, _PureComponent);

  function ErrorScreen() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ErrorScreen);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ErrorScreen).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ErrorScreen, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.container
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.title
      }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-arrange.fatalApplicationLoadErrorTitle")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_8__index_css___default.a.body
      }, void 0, __WEBPACK_IMPORTED_MODULE_7__zendesk_client_i18n_tools___default()("knowledge-arrange.fatalApplicationLoadErrorBody")));
    }
  }]);

  return ErrorScreen;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);



/***/ }),

/***/ 63:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-ErrorScreen-index---container---GxfwM","title":"_-src-components-ErrorScreen-index---title---1FwCw"};

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_loaders__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__index_css__);












var _ref5 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("g", {
  fill: "currentColor"
}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "1",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "1",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "5",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "5",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "9",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "9",
  rx: ".5",
  ry: ".5"
}));

var GripIcon = function GripIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("svg", props, _ref5);
};

GripIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
};



var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("g", {
  fill: "currentColor"
}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "7",
  cy: "13",
  r: "2"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "13",
  cy: "13",
  r: "2"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "19",
  cy: "13",
  r: "2"
}));

var EllipsisIcon = function EllipsisIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("svg", props, _ref6);
};

EllipsisIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  viewBox: "0 0 26 26"
};



var KEY_ENTER = 13;

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(EllipsisIcon, {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(GripIcon, {});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_loaders__["Spinner"], {
  delayMs: 0
});

var CategoryRow =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(CategoryRow, _Component);

  function CategoryRow(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, CategoryRow);

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(CategoryRow).call(this, props));
    _this.state = {
      isMoveToModalVisible: false
    };
    _this.onKeyDown = _this.onKeyDown.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onEditClick = _this.onEditClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onViewClick = _this.onViewClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onMoveToClick = _this.onMoveToClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onModalClose = _this.onModalClose.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onMoveToTop = _this.onMoveToTop.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(CategoryRow, [{
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var onClick = this.props.onClick;

      if (e.keyCode === KEY_ENTER) {
        onClick();
      }
    }
  }, {
    key: "onEditClick",
    value: function onEditClick(e) {
      e.stopPropagation();
      var category = this.props.category;
      window.open(category.edit_url, "_blank");
    }
  }, {
    key: "onViewClick",
    value: function onViewClick(e) {
      e.stopPropagation();
      var category = this.props.category;
      window.open(category.html_url, "_blank");
    }
  }, {
    key: "onMoveToClick",
    value: function onMoveToClick(e) {
      e.stopPropagation();
      this.setState({
        isMoveToModalVisible: true
      });
    }
  }, {
    key: "onMoveToTop",
    value: function onMoveToTop(e) {
      e.stopPropagation();
      var onMoveToTop = this.props.onMoveToTop;
      onMoveToTop();
    }
  }, {
    key: "onModalClose",
    value: function onModalClose() {
      this.setState({
        isMoveToModalVisible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2;

      var _this$props = this.props,
          category = _this$props.category,
          testId = _this$props.testId,
          onClick = _this$props.onClick,
          highlight = _this$props.highlight,
          dragHandleProps = _this$props.dragHandleProps,
          saving = _this$props.saving,
          success = _this$props.success;

      var menu = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["Menu"], {
        "data-test-id": testId && "".concat(testId, "-menu"),
        trigger: function trigger(_ref) {
          var ref = _ref.ref,
              isOpen = _ref.isOpen;
          return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span", {
            ref: ref,
            role: "button",
            tabIndex: 0,
            "aria-label": __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.section.menuAriaLabel"),
            className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(__WEBPACK_IMPORTED_MODULE_15__index_css___default.a.trigger, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.open, isOpen)),
            "data-test-id": testId && "".concat(testId, "-menu-trigger"),
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }, _ref2);
        }
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-edit"),
        onClick: this.onEditClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.category.edit")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-move-to-top"),
        onClick: this.onMoveToTop
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.category.sendToTop")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-view"),
        onClick: this.onViewClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.category.view")));

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        tabIndex: 0,
        className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(__WEBPACK_IMPORTED_MODULE_15__index_css___default.a.row, (_classnames2 = {}, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.saving, saving), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.success, success), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.highlight, highlight), _classnames2)),
        onClick: onClick,
        onKeyDown: this.onKeyDown,
        "data-test-id": testId && "".concat(testId, "-row")
      }, void 0, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        role: "button",
        tabIndex: 0,
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.grip,
        "data-test-id": testId && "".concat(testId, "-drag-handle")
      }, dragHandleProps), _ref3), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.content
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.name,
        "data-test-id": testId && "".concat(testId, "-name")
      }, void 0, category.name), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.additional,
        "data-test-id": testId && "".concat(testId, "-detail")
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.sectionCount", {
        count: category.section_count
      }))), saving ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_15__index_css___default.a.loader
      }, void 0, _ref4) : menu));
    }
  }]);

  return CategoryRow;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);


CategoryRow.defaultProps = {
  highlight: false,
  saving: false,
  success: false
};
CategoryRow.propTypes = {
  category: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].shape({
    name: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    html_url: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    edit_url: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired
  }).isRequired,
  testId: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string,
  onClick: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  onMoveToTop: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  highlight: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  dragHandleProps: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].object,
  saving: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  success: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool
};

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(276)
  , defined = __webpack_require__(181);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"_-src-components-CategoryRow-index---row---1C6CV","highlight":"_-src-components-CategoryRow-index---highlight---7hw2T","name":"_-src-components-CategoryRow-index---name---3sBB0","additional":"_-src-components-CategoryRow-index---additional---1X_ss","trigger":"_-src-components-CategoryRow-index---trigger---27CtH","open":"_-src-components-CategoryRow-index---open---3ctM-","content":"_-src-components-CategoryRow-index---content---DmQya","loader":"_-src-components-CategoryRow-index---loader---i3xvb","saving":"_-src-components-CategoryRow-index---saving---1Jqgv","success":"_-src-components-CategoryRow-index---success---131pj","grip":"_-src-components-CategoryRow-index---grip---1lCdt"};

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"empty":"_-src-components-Empty-index---empty---vXxr9","title":"_-src-components-Empty-index---title---3nxdB","description":"_-src-components-Empty-index---description---OZaxJ","actions":"_-src-components-Empty-index---actions---2iwKR"};

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loadingOverlay":"_-src-components-LoadingOverlay-index---loadingOverlay---Vr7bW","loaderWrapper":"_-src-components-LoadingOverlay-index---loaderWrapper---fURKi"};

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"appHeader":"_-src-components-CategoryList-index---appHeader---1zMv9","title":"_-src-components-CategoryList-index---title---3fyYM","listHeader":"_-src-components-CategoryList-index---listHeader---3JR2P","addNewButton":"_-src-components-CategoryList-index---addNewButton---3cuiL","icon":"_-src-components-CategoryList-index---icon---3WhJx","content":"_-src-components-CategoryList-index---content---3eWDZ","loader":"_-src-components-CategoryList-index---loader---2uCkG","draggable":"_-src-components-CategoryList-index---draggable---29mJ2"};

/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Category */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_connected_react_router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_guide_chrome__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_guide_chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_guide_chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_buttons__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Breadcrumbs__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Breadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_beautiful_dnd__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_createBrandedUrl__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_createBrandedUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_createBrandedUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_category__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_section__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ErrorBoundary__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SectionList__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LoadingOverlay__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Empty__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Notifications__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_pathForBreadcrumb__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__index_css__);





























var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_23__LoadingOverlay__["a" /* default */], {});

var Category =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Category, _Component);

  function Category(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Category);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Category).call(this, props));
    _this.onPageSelected = _this.onPageSelected.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.openNewSectionPage = _this.openNewSectionPage.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onDragEnd = _this.onDragEnd.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onBreadcrumbClick = _this.onBreadcrumbClick.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onMoveToTop = _this.onMoveToTop.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Category, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          dispatch = _this$props.dispatch,
          sectionPage = _this$props.sectionPage,
          categoryId = _this$props.categoryId;
      dispatch(__WEBPACK_IMPORTED_MODULE_19__actions_category__["a" /* fetchCategory */](categoryId, sectionPage));
    }
  }, {
    key: "openNewSectionPage",
    value: function openNewSectionPage() {
      var categoryId = this.props.categoryId;
      window.open("/knowledge/sections/new?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getCurrentBrandId"])(), "&category_id=").concat(categoryId), "_blank");
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      var _this$props2 = this.props,
          dispatch = _this$props2.dispatch,
          categoryId = _this$props2.categoryId;
      dispatch(__WEBPACK_IMPORTED_MODULE_19__actions_category__["b" /* fetchSections */](categoryId, {
        page: page
      }));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_connected_react_router__["push"])({
        pathname: "/knowledge/arrange/categories/".concat(categoryId, "/page/").concat(page),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(dragEnd) {
      var combine = dragEnd.combine,
          source = dragEnd.source,
          destination = dragEnd.destination,
          type = dragEnd.type,
          draggableId = dragEnd.draggableId;
      var _this$props3 = this.props,
          dispatch = _this$props3.dispatch,
          categoryId = _this$props3.categoryId;
      var isPositioning = destination && !(source.droppableId === destination.droppableId && source.index === destination.index);

      if (!isPositioning && !combine) {
        return;
      }

      if (combine) {
        dispatch(__WEBPACK_IMPORTED_MODULE_20__actions_section__["g" /* moveSectionToSection */](draggableId, // moved section
        combine.draggableId, // destination section
        source.index));
      } else if (type === "section" && destination.droppableId === "sections") {
        dispatch(__WEBPACK_IMPORTED_MODULE_19__actions_category__["d" /* positionSection */](categoryId, draggableId, source.index, destination.index));
      }
    }
  }, {
    key: "onBreadcrumbClick",
    value: function onBreadcrumbClick(item) {
      var dispatch = this.props.dispatch;
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_connected_react_router__["push"])({
        pathname: Object(__WEBPACK_IMPORTED_MODULE_26__utils_pathForBreadcrumb__["a" /* pathForBreadcrumb */])(item),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }
  }, {
    key: "onMoveToTop",
    value: function onMoveToTop(section, sourceIndex) {
      var dispatch = this.props.dispatch;
      dispatch(__WEBPACK_IMPORTED_MODULE_19__actions_category__["c" /* moveSectionToTop */](section, sourceIndex));
    }
  }, {
    key: "renderBreadcrumbs",
    value: function renderBreadcrumbs() {
      var _this$props4 = this.props,
          breadcrumbs = _this$props4.breadcrumbs,
          isFetching = _this$props4.isFetching;

      if (isFetching) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Breadcrumbs___default.a, {
        breadcrumbs: breadcrumbs,
        onBreadcrumbClick: this.onBreadcrumbClick
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props5 = this.props,
          isFetching = _this$props5.isFetching,
          sectionCount = _this$props5.sectionCount,
          sectionPage = _this$props5.sectionPage;

      if (isFetching) {
        return null;
      }

      if (sectionCount === 0) {
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__Empty__["a" /* default */], {
          testId: "empty-category"
        }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__Empty__["a" /* default */].Title, {}, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.category.empty")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__Empty__["a" /* default */].Description, {}, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.category.emptyDescription")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__Empty__["a" /* default */].Actions, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendeskgarden_react_buttons__["Button"], {
          primary: true,
          "data-test-id": "empty-add-section",
          size: "small",
          onClick: this.openNewSectionPage
        }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.sections.addSection"))));
      }

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_22__SectionList__["a" /* default */], {
        onMoveToTop: this.onMoveToTop,
        onPageSelected: this.onPageSelected,
        page: sectionPage,
        count: sectionCount
      });
    }
  }, {
    key: "render",
    value: function render() {
      var hasCommunity = this.props.hasCommunity;
      var hc = Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getHelpCenter"])();
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        brandId: Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getCurrentBrandId"])(),
        dir: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default.a.dir,
        topNav: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("a", {
          href: "/knowledge/arrange?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getCurrentBrandId"])())
        }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.breadcrumbs.arrangeContent"))), _ref, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.name")))
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_guide_chrome__["Sidebar"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_guide_chrome__["Sidebar"].Item, {
        active: true,
        testId: "sidebar-user-segments-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.name")), hasCommunity && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_createBrandedUrl___default()(hc.route.subdomain, "/hc/admin/arrange_contents#community"),
        testId: "sidebar-arrange-topics-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.sidebar.arrangeTopics")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: __WEBPACK_IMPORTED_MODULE_18__zendesk_knowledge_utils_lib_createBrandedUrl___default()(hc.route.subdomain, "/hc/admin/import_articles"),
        testId: "sidebar-import-articles-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.sidebar.importArticles"))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_guide_chrome__["ContentView"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_21__ErrorBoundary__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_25__Notifications__["a" /* default */], {
        dir: __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default.a.dir
      }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.appHeader
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("h1", {
        className: __WEBPACK_IMPORTED_MODULE_27__index_css___default.a.title
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.name"))), this.renderBreadcrumbs(), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17_react_beautiful_dnd__["a" /* DragDropContext */], {
        onDragEnd: this.onDragEnd
      }, void 0, this.renderContent()), _ref2)));
    }
  }]);

  return Category;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);
Category.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].func,
  categoryId: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].string.isRequired,
  isFetching: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].bool.isRequired,
  sectionCount: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].number.isRequired,
  sectionPage: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].number.isRequired,
  breadcrumbs: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].string.isRequired
  })).isRequired,
  hasCommunity: __WEBPACK_IMPORTED_MODULE_8_prop_types__["PropTypes"].bool
};

var mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var category = _ref3.category,
      sections = _ref3.sections;
  var match = _ref4.match;
  var page = parseInt(match.params.page, 10);
  return {
    categoryId: match.params.id,
    isFetching: category.isFetching,
    sectionCount: category.sectionCount,
    sectionPage: isNaN(page) ? 1 : page,
    breadcrumbs: category.breadcrumbs,
    hasCommunity: Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["hasFeature"])("community") && Object(__WEBPACK_IMPORTED_MODULE_13__zendesk_knowledge_context__["getHelpCenter"])().community
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(mapStateToProps)(Category));

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchSections;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCategory;
/* harmony export (immutable) */ __webpack_exports__["d"] = positionSection;
/* harmony export (immutable) */ __webpack_exports__["c"] = moveSectionToTop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_positioning__ = __webpack_require__(74);







function fetchSectionsRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["d" /* FETCH_CATEGORY_SECTIONS_REQUEST */]
  };
}

function fetchSectionsSuccess(sections, page, pageCount, count) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["e" /* FETCH_CATEGORY_SECTIONS_SUCCESS */],
    sections: sections,
    page: page,
    pageCount: pageCount,
    count: count
  };
}

function fetchSectionsFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["c" /* FETCH_CATEGORY_SECTIONS_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchSections(categoryId, _ref) {
  var page = _ref.page;
  return function (dispatch, getState) {
    dispatch(fetchSectionsRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("/hc/api/internal/arrange_articles/categories/".concat(categoryId, "/sections?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCurrentBrandId"])(), "&page=").concat(page, "&per_page=30")).then(function (_ref2) {
      var sections = _ref2.sections,
          page = _ref2.page,
          page_count = _ref2.page_count,
          count = _ref2.count;
      return dispatch(fetchSectionsSuccess(sections, page, page_count, count));
    }).catch(function (err) {
      dispatch(fetchSectionsFailure(err));
    });
  };
}

function fetchCategoryRequest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["b" /* FETCH_CATEGORY_REQUEST */]
  };
}

function fetchCategorySuccess(category) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["f" /* FETCH_CATEGORY_SUCCESS */],
    category: category
  };
}

function fetchCategoryFailure(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["a" /* FETCH_CATEGORY_FAILURE */],
    error: true,
    payload: error
  };
}

function fetchCategory(id, sectionPage) {
  return function (dispatch, getState) {
    dispatch(fetchCategoryRequest());
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["get"])("/hc/api/internal/arrange_articles/categories/".concat(id, "?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCurrentBrandId"])())).then(function (_ref3) {
      var category = _ref3.category;
      dispatch(fetchSections(id, {
        page: sectionPage
      }));
      dispatch(fetchCategorySuccess(category));
    }).catch(function (err) {
      dispatch(fetchCategoryFailure(err));
    });
  };
}

function positionSectionRequest(sourceIndex, destinationIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["k" /* POSITION_CATEGORY_SECTION_REQUEST */],
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionSectionSuccess(sourceIndex, destinationIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["l" /* POSITION_CATEGORY_SECTION_SUCCESS */],
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionSectionFailure(sourceIndex, destinationIndex, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["j" /* POSITION_CATEGORY_SECTION_FAILURE */],
    error: true,
    payload: error,
    sourceIndex: sourceIndex,
    destinationIndex: destinationIndex
  };
}

function positionSection(categoryId, positionedSectionId, sourceIndex, destinationIndex) {
  return function (dispatch, getState) {
    var _getState = getState(),
        list = _getState.sections.list;

    var payload = {
      positioned_section_id: positionedSectionId
    };

    if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["d" /* isMovingDown */])(sourceIndex, destinationIndex)) {
      var item = Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["b" /* getItemAbove */])(list, sourceIndex, destinationIndex);
      payload.below_id = item && item.id;
    } else {
      var _item = Object(__WEBPACK_IMPORTED_MODULE_5__utils_positioning__["c" /* getItemBelow */])(list, sourceIndex, destinationIndex);

      payload.above_id = _item && _item.id;
    }

    dispatch(positionSectionRequest(sourceIndex, destinationIndex));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["post"])("/hc/api/internal/arrange_articles/categories/".concat(categoryId, "/position_section?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCurrentBrandId"])()), payload, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(positionSectionSuccess(sourceIndex, destinationIndex));
    }).catch(function (err) {
      dispatch(positionSectionFailure(sourceIndex, destinationIndex, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.sectionPositioned.failure")));
    });
  };
}

function moveSectionToTopRequest(sourceIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["h" /* MOVE_CATEGORY_SECTION_TO_TOP_REQUEST */],
    sourceIndex: sourceIndex
  };
}

function moveSectionToTopSuccess(sourceIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["i" /* MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS */],
    sourceIndex: sourceIndex
  };
}

function moveSectionToTopFailure(sourceIndex, item, error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__types__["g" /* MOVE_CATEGORY_SECTION_TO_TOP_FAILURE */],
    error: true,
    payload: error,
    sourceIndex: sourceIndex,
    item: item
  };
}

function moveSectionToTop(movedSection, sourceIndex) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        category = _getState2.category;

    dispatch(moveSectionToTopRequest(sourceIndex));
    return Object(__WEBPACK_IMPORTED_MODULE_1__zendesk_knowledge_http_client__["post"])("/hc/api/internal/arrange_articles/categories/".concat(category.id, "/position_section?multibrand=true&brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCurrentBrandId"])()), {
      positioned_section_id: movedSection.id,
      below_id: null
    }, {
      csrfToken: Object(__WEBPACK_IMPORTED_MODULE_4__zendesk_knowledge_context__["getCSRFToken"])()
    }).then(function () {
      dispatch(moveSectionToTopSuccess(sourceIndex));
    }).catch(function (err) {
      dispatch(moveSectionToTopFailure(sourceIndex, movedSection, err));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__zendesk_knowledge_redux_lib_actions_NotificationActions__["showError"])(__WEBPACK_IMPORTED_MODULE_2__zendesk_client_i18n_tools___default()("knowledge-arrange.notification.sectionPositioned.failure")));
    });
  };
}

/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_loaders__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_menus__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MoveToModal__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__index_css__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__index_css__);












var _ref5 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("g", {
  fill: "currentColor"
}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "1",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "1",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "5",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "5",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "9",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "9",
  rx: ".5",
  ry: ".5"
}));

var GripIcon = function GripIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("svg", props, _ref5);
};

GripIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
};




var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("g", {
  fill: "currentColor"
}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "7",
  cy: "13",
  r: "2"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "13",
  cy: "13",
  r: "2"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "19",
  cy: "13",
  r: "2"
}));

var EllipsisIcon = function EllipsisIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("svg", props, _ref6);
};

EllipsisIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  viewBox: "0 0 26 26"
};




var KEY_ENTER = 13;

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(EllipsisIcon, {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(GripIcon, {});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_loaders__["Spinner"], {
  delayMs: 0
});

var SectionRow =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(SectionRow, _Component);

  function SectionRow(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, SectionRow);

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(SectionRow).call(this, props));
    _this.state = {
      isMoveToModalVisible: false
    };
    _this.onKeyDown = _this.onKeyDown.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onEditClick = _this.onEditClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onViewClick = _this.onViewClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onMoveToClick = _this.onMoveToClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onModalClose = _this.onModalClose.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onMoveToTop = _this.onMoveToTop.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(SectionRow, [{
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var onClick = this.props.onClick;

      if (e.keyCode === KEY_ENTER) {
        onClick();
      }
    }
  }, {
    key: "onEditClick",
    value: function onEditClick(e) {
      e.stopPropagation();
      var section = this.props.section;
      window.open("/knowledge/sections/".concat(section.id, "?brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_context__["getCurrentBrandId"])()), "_blank");
    }
  }, {
    key: "onViewClick",
    value: function onViewClick(e) {
      e.stopPropagation();
      var section = this.props.section;
      window.open(section.html_url, "_blank");
    }
  }, {
    key: "onMoveToClick",
    value: function onMoveToClick(e) {
      e.stopPropagation();
      this.setState({
        isMoveToModalVisible: true
      });
    }
  }, {
    key: "onModalClose",
    value: function onModalClose() {
      this.setState({
        isMoveToModalVisible: false
      });
    }
  }, {
    key: "onMoveToTop",
    value: function onMoveToTop(e) {
      e.stopPropagation();
      var onMoveToTop = this.props.onMoveToTop;
      onMoveToTop();
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2;

      var _this$props = this.props,
          section = _this$props.section,
          testId = _this$props.testId,
          onClick = _this$props.onClick,
          highlight = _this$props.highlight,
          dragHandleProps = _this$props.dragHandleProps,
          saving = _this$props.saving,
          success = _this$props.success,
          onMoveTo = _this$props.onMoveTo;
      var isMoveToModalVisible = this.state.isMoveToModalVisible;

      var menu = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_menus__["Menu"], {
        "data-test-id": testId && "".concat(testId, "-menu"),
        trigger: function trigger(_ref) {
          var ref = _ref.ref,
              isOpen = _ref.isOpen;
          return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span", {
            ref: ref,
            role: "button",
            tabIndex: 0,
            "aria-label": __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.section.menuAriaLabel"),
            className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_17__index_css___default.a.trigger, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.open, isOpen)),
            "data-test-id": testId && "".concat(testId, "-menu-trigger"),
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }, _ref2);
        }
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-edit"),
        onClick: this.onEditClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.section.edit")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-move-to"),
        onClick: this.onMoveToClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.moveTo.menuItem")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-move-to-top"),
        onClick: this.onMoveToTop
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.section.sendToTop")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-view"),
        onClick: this.onViewClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.section.view")));

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, isMoveToModalVisible && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__MoveToModal__["a" /* default */], {
        onMove: onMoveTo,
        onClose: this.onModalClose,
        name: section.name,
        destinationTypes: ["Section", "Category"]
      }), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        tabIndex: 0,
        className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(__WEBPACK_IMPORTED_MODULE_17__index_css___default.a.row, (_classnames2 = {}, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.saving, saving), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.success, success), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.highlight, highlight), _classnames2)),
        onClick: onClick,
        onKeyDown: this.onKeyDown,
        "data-test-id": testId && "".concat(testId, "-row")
      }, void 0, __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        role: "button",
        tabIndex: 0,
        className: __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.grip,
        "data-test-id": testId && "".concat(testId, "-drag-handle")
      }, dragHandleProps), _ref3), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.content
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.name,
        "data-test-id": testId && "".concat(testId, "-name")
      }, void 0, section.name), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.additional,
        "data-test-id": testId && "".concat(testId, "-detail")
      }, void 0, __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.sectionCount", {
        count: section.section_count
      }), " ", "\xB7", " ", __WEBPACK_IMPORTED_MODULE_14__zendesk_client_i18n_tools___default()("knowledge-arrange.articleCount", {
        count: section.article_count
      }))), saving ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_17__index_css___default.a.loader
      }, void 0, _ref4) : menu));
    }
  }]);

  return SectionRow;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);


SectionRow.defaultProps = {
  highlight: false,
  saving: false,
  success: false
};
SectionRow.propTypes = {
  section: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].shape({
    name: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    edit_url: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    html_url: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    section_count: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired,
    article_count: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired
  }).isRequired,
  testId: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string,
  onClick: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  highlight: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  dragHandleProps: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].object,
  saving: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  success: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  onMoveTo: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func.isRequired,
  onMoveToTop: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func.isRequired
};

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _View = __webpack_require__(668);

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_View).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(669);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(678);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(679);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(680);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(704);

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__(712);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(23);

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = __webpack_require__(716);

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasAnyHandlers = function hasAnyHandlers(handlers) {
  return (0, _keys2.default)(handlers).some(function (key) {
    return handlers[key];
  });
};

var View = function (_Component) {
  (0, _inherits3.default)(View, _Component);

  function View() {
    (0, _classCallCheck3.default)(this, View);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  View.prototype.componentDidMount = function componentDidMount() {
    var autoFocus = this.props.autoFocus;


    if (autoFocus) {
      this.element.focus();
    }
  };

  View.prototype.componentWillUnmount = function componentWillUnmount() {
    var tooltips = this.context.tooltips;


    if (tooltips && this.tooltipId != null) {
      tooltips.hide(this.tooltipId);
    }
  };

  View.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        hidden = _props.hidden,
        onArrowDown = _props.onArrowDown,
        onArrowLeft = _props.onArrowLeft,
        onArrowRight = _props.onArrowRight,
        onArrowUp = _props.onArrowUp,
        onDelete = _props.onDelete,
        onEnter = _props.onEnter,
        onEscape = _props.onEscape,
        onKeyDown = _props.onKeyDown,
        onSpace = _props.onSpace,
        onTab = _props.onTab,
        title = _props.title,
        tooltipPositioning = _props.tooltipPositioning,
        testId = _props.testId,
        other = (0, _objectWithoutProperties3.default)(_props, ["children", "className", "hidden", "onArrowDown", "onArrowLeft", "onArrowRight", "onArrowUp", "onDelete", "onEnter", "onEscape", "onKeyDown", "onSpace", "onTab", "title", "tooltipPositioning", "testId"]);


    var keyDownHandlers = {
      "8": onDelete,
      "9": onTab,
      "13": onEnter,
      "27": onEscape,
      "32": onSpace,
      "37": onArrowLeft,
      "38": onArrowUp,
      "39": onArrowRight,
      "40": onArrowDown
    };

    var eventHandlers = {};

    if (onKeyDown || hasAnyHandlers(keyDownHandlers)) {
      eventHandlers.onKeyDown = function (e) {
        var handler = keyDownHandlers[e.keyCode];
        handler && handler(e);
        onKeyDown && onKeyDown(e);
      };
    }

    var props = (0, _extends3.default)({}, other, eventHandlers);

    var tooltips = this.context.tooltips;


    if (tooltips && title) {
      props.onMouseEnter = function (e) {
        _this2.tooltipId = tooltips.show(_this2.element, title, tooltipPositioning);
        _this2.props.onMouseOver && _this2.props.onMouseOver(e);
      };
      ["onMouseLeave", "onBlur", "onWheel", "onClick"].forEach(function (handler) {
        props[handler] = function (e) {
          tooltips.hide(_this2.tooltipId);
          _this2.props[handler] && _this2.props[handler](e);
        };
      });

      props["aria-label"] = title;
    } else if (title) {
      props.title = title;
    }

    if (testId) {
      props["data-test-id"] = testId;
    }

    if (hidden) {
      props["aria-hidden"] = true;
    }

    return _react2.default.createElement(
      "div",
      (0, _extends3.default)({}, props, {
        className: (0, _classnames2.default)(_styles2.default.view, className),
        ref: function ref(_ref) {
          _this2.element = _ref;
        }
      }),
      children
    );
  };

  return View;
}(_react.Component);

View.propTypes = {
  autoFocus: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  dir: _propTypes2.default.oneOf(["ltr", "rtl"]),
  hidden: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onDragEnter: _propTypes2.default.func,
  onDragLeave: _propTypes2.default.func,
  onDragOver: _propTypes2.default.func,
  onDragStart: _propTypes2.default.func,
  onDrop: _propTypes2.default.func,
  onArrowDown: _propTypes2.default.func,
  onArrowLeft: _propTypes2.default.func,
  onArrowRight: _propTypes2.default.func,
  onArrowUp: _propTypes2.default.func,
  onBackspace: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEnter: _propTypes2.default.func,
  onEscape: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onScroll: _propTypes2.default.func,
  onSpace: _propTypes2.default.func,
  onTab: _propTypes2.default.func,
  testId: _propTypes2.default.string,
  /** Hiding advanced content within tooltips may have accessibility impacts */
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  /** One of: 'top', 'right', 'bottom', 'left' or as array (prioritization) */
  tooltipPositioning: function tooltipPositioning() {}
};
View.contextTypes = {
  tooltips: _propTypes2.default.object
};
exports.default = View;

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(670);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(671), __esModule: true };

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(672);
module.exports = __webpack_require__(52).Object.assign;

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(75);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(674)});

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(80)
  , gOPS     = __webpack_require__(186)
  , pIE      = __webpack_require__(131)
  , toObject = __webpack_require__(187)
  , IObject  = __webpack_require__(276)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(79)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(64)
  , toLength  = __webpack_require__(676)
  , toIndex   = __webpack_require__(677);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(182)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(182)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(278);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(682), __esModule: true };

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(683);
__webpack_require__(689);
module.exports = __webpack_require__(192).f('iterator');

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(684)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(279)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(182)
  , defined   = __webpack_require__(181);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(190)
  , descriptor     = __webpack_require__(129)
  , setToStringTag = __webpack_require__(191)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(76)(IteratorPrototype, __webpack_require__(81)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(77)
  , anObject = __webpack_require__(100)
  , getKeys  = __webpack_require__(80);

module.exports = __webpack_require__(78) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(51).document && document.documentElement;

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(63)
  , toObject    = __webpack_require__(187)
  , IE_PROTO    = __webpack_require__(183)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(690);
var global        = __webpack_require__(51)
  , hide          = __webpack_require__(76)
  , Iterators     = __webpack_require__(189)
  , TO_STRING_TAG = __webpack_require__(81)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(691)
  , step             = __webpack_require__(692)
  , Iterators        = __webpack_require__(189)
  , toIObject        = __webpack_require__(64);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(279)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(694), __esModule: true };

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(695);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
module.exports = __webpack_require__(52).Symbol;

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(51)
  , has            = __webpack_require__(63)
  , DESCRIPTORS    = __webpack_require__(78)
  , $export        = __webpack_require__(75)
  , redefine       = __webpack_require__(280)
  , META           = __webpack_require__(696).KEY
  , $fails         = __webpack_require__(79)
  , shared         = __webpack_require__(184)
  , setToStringTag = __webpack_require__(191)
  , uid            = __webpack_require__(130)
  , wks            = __webpack_require__(81)
  , wksExt         = __webpack_require__(192)
  , wksDefine      = __webpack_require__(193)
  , keyOf          = __webpack_require__(697)
  , enumKeys       = __webpack_require__(698)
  , isArray        = __webpack_require__(699)
  , anObject       = __webpack_require__(100)
  , toIObject      = __webpack_require__(64)
  , toPrimitive    = __webpack_require__(180)
  , createDesc     = __webpack_require__(129)
  , _create        = __webpack_require__(190)
  , gOPNExt        = __webpack_require__(700)
  , $GOPD          = __webpack_require__(282)
  , $DP            = __webpack_require__(77)
  , $keys          = __webpack_require__(80)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(281).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(131).f  = $propertyIsEnumerable;
  __webpack_require__(186).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(188)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(76)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(130)('meta')
  , isObject = __webpack_require__(101)
  , has      = __webpack_require__(63)
  , setDesc  = __webpack_require__(77).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(79)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(80)
  , toIObject = __webpack_require__(64);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(80)
  , gOPS    = __webpack_require__(186)
  , pIE     = __webpack_require__(131);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(277);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(64)
  , gOPN      = __webpack_require__(281).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 701:
/***/ (function(module, exports) {



/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(193)('asyncIterator');

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(193)('observable');

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(705);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(709);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(278);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(706), __esModule: true };

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(707);
module.exports = __webpack_require__(52).Object.setPrototypeOf;

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(75);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(708).set});

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(101)
  , anObject = __webpack_require__(100);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(272)(Function.call, __webpack_require__(282).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(710), __esModule: true };

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(711);
var $Object = __webpack_require__(52).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(75)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(190)});

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(713), __esModule: true };

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(714);
module.exports = __webpack_require__(52).Object.keys;

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(187)
  , $keys    = __webpack_require__(80);

__webpack_require__(715)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(75)
  , core    = __webpack_require__(52)
  , fails   = __webpack_require__(79);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var appendStyles = __webpack_require__(717)


appendStyles({
  css: ".ssc-view-3cf51d67[aria-hidden=true]{display:none}.ssc-inline-3cf51d67{display:inline-block}",
  id: 'rc-styles',
  before: 'ssc-styles'
})

exports.default = {"view":"ssc-view-3cf51d67","inline":"ssc-inline-3cf51d67"}


/***/ }),

/***/ 724:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"_-src-components-MoveToModal-index---body---1Kkcy","description":"_-src-components-MoveToModal-index---description---1i675","name":"_-src-components-MoveToModal-index---name---35XTc"};

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"_-src-components-SectionRow-index---row---3WUIk","highlight":"_-src-components-SectionRow-index---highlight---2L8su","name":"_-src-components-SectionRow-index---name---25EQN","additional":"_-src-components-SectionRow-index---additional---2FFge","trigger":"_-src-components-SectionRow-index---trigger---1bWrZ","open":"_-src-components-SectionRow-index---open---2a8VP","content":"_-src-components-SectionRow-index---content---lylGQ","loader":"_-src-components-SectionRow-index---loader---15JDO","saving":"_-src-components-SectionRow-index---saving---19tPd","success":"_-src-components-SectionRow-index---success---1tSPN","grip":"_-src-components-SectionRow-index---grip---vl2ZE"};

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"appTitle":"_-src-components-SectionList-index---appTitle---3L8M2","loader":"_-src-components-SectionList-index---loader---Nnt7C","container":"_-src-components-SectionList-index---container---3GMae","draggable":"_-src-components-SectionList-index---draggable---2CFaH","listHeader":"_-src-components-SectionList-index---listHeader---1dgWr"};

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"appHeader":"_-src-components-Category-index---appHeader---3X9Ka","title":"_-src-components-Category-index---title---2YG1_","loader":"_-src-components-Category-index---loader---3ZYtH"};

/***/ }),

/***/ 728:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Section */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_connected_react_router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_components_lib_Gap__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_components_lib_Gap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_components_lib_Gap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Breadcrumbs__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Breadcrumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendeskgarden_react_buttons__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__zendeskgarden_react_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__zendeskgarden_react_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_beautiful_dnd__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__zendesk_knowledge_utils_lib_createBrandedUrl__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__zendesk_knowledge_utils_lib_createBrandedUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__zendesk_knowledge_utils_lib_createBrandedUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_section__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ErrorBoundary__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LoadingOverlay__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SectionList__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ArticleList__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Empty__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Notifications__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_pathForBreadcrumb__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__index_css__);































var _ref =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_15__zendesk_knowledge_components_lib_Gap___default.a.Medium, {});

var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Separator, {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_23__LoadingOverlay__["a" /* default */], {});

var Section =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Section, _Component);

  function Section(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Section);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Section).call(this, props));
    _this.onSectionPageSelected = _this.onSectionPageSelected.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onArticlePageSelected = _this.onArticlePageSelected.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.openNewSectionPage = _this.openNewSectionPage.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.openNewArticlePage = _this.openNewArticlePage.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onDragEnd = _this.onDragEnd.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onBreadcrumbClick = _this.onBreadcrumbClick.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onSectionMoveToTop = _this.onSectionMoveToTop.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onArticleMoveToTop = _this.onArticleMoveToTop.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Section, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          dispatch = _this$props.dispatch,
          sectionPage = _this$props.sectionPage,
          articlePage = _this$props.articlePage,
          sectionId = _this$props.sectionId;
      dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["b" /* fetchSection */](sectionId, sectionPage, articlePage));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          dispatch = _this$props2.dispatch,
          sectionPage = _this$props2.sectionPage,
          articlePage = _this$props2.articlePage,
          sectionId = _this$props2.sectionId;

      if (prevProps.sectionId !== sectionId) {
        dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["b" /* fetchSection */](sectionId, sectionPage, articlePage));
      }
    }
  }, {
    key: "openNewSectionPage",
    value: function openNewSectionPage() {
      var sectionId = this.props.sectionId;
      window.open("/knowledge/sections/new?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])(), "&parent_section_id=").concat(sectionId), "_blank");
    }
  }, {
    key: "openNewArticlePage",
    value: function openNewArticlePage() {
      var sectionId = this.props.sectionId;
      window.open("/knowledge/articles/new?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])(), "&section_id=").concat(sectionId), "_blank");
    }
  }, {
    key: "onSectionPageSelected",
    value: function onSectionPageSelected(page) {
      var _this$props3 = this.props,
          dispatch = _this$props3.dispatch,
          sectionId = _this$props3.sectionId,
          articlePage = _this$props3.articlePage;
      dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["c" /* fetchSections */](sectionId, {
        page: page
      }));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_connected_react_router__["push"])({
        pathname: "/knowledge/arrange/sections/".concat(sectionId, "/section_page/").concat(page, "/article_page/").concat(articlePage),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }
  }, {
    key: "onArticlePageSelected",
    value: function onArticlePageSelected(page) {
      var _this$props4 = this.props,
          dispatch = _this$props4.dispatch,
          sectionId = _this$props4.sectionId,
          sectionPage = _this$props4.sectionPage;
      dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["a" /* fetchArticles */](sectionId, {
        page: page
      }));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_connected_react_router__["push"])({
        pathname: "/knowledge/arrange/sections/".concat(sectionId, "/section_page/").concat(sectionPage, "/article_page/").concat(page),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(dragEnd) {
      var combine = dragEnd.combine,
          source = dragEnd.source,
          destination = dragEnd.destination,
          type = dragEnd.type,
          draggableId = dragEnd.draggableId;
      var _this$props5 = this.props,
          dispatch = _this$props5.dispatch,
          sectionId = _this$props5.sectionId;
      var isPositioning = destination && !(source.droppableId === destination.droppableId && source.index === destination.index);

      if (!isPositioning && !combine) {
        return;
      }

      if (combine) {
        dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["g" /* moveSectionToSection */](draggableId, // moved section
        combine.draggableId, // destination section
        source.index));
      } else if (type === "article" && destination.droppableId === "articles") {
        dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["i" /* positionArticle */](sectionId, draggableId, source.index, destination.index));
      } else if (type === "article") {
        var _destination$droppabl = destination.droppableId.split("-"),
            _destination$droppabl2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_destination$droppabl, 2),
            droppableType = _destination$droppabl2[0],
            droppableId = _destination$droppabl2[1];

        if (droppableType === "section" && droppableId) {
          dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["d" /* moveArticleToSection */](draggableId, Number(droppableId), source.index));
        }
      } else if (type === "section" && destination.droppableId === "sections") {
        dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["j" /* positionSection */](sectionId, draggableId, source.index, destination.index));
      }
    }
  }, {
    key: "onBreadcrumbClick",
    value: function onBreadcrumbClick(item) {
      var dispatch = this.props.dispatch;
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_connected_react_router__["push"])({
        pathname: Object(__WEBPACK_IMPORTED_MODULE_28__utils_pathForBreadcrumb__["a" /* pathForBreadcrumb */])(item),
        search: "?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])())
      }));
    }
  }, {
    key: "onSectionMoveToTop",
    value: function onSectionMoveToTop(section, sourceIndex) {
      var dispatch = this.props.dispatch;
      dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["h" /* moveSectionToTop */](section, sourceIndex));
    }
  }, {
    key: "onArticleMoveToTop",
    value: function onArticleMoveToTop(article, sourceIndex) {
      var dispatch = this.props.dispatch;
      dispatch(__WEBPACK_IMPORTED_MODULE_21__actions_section__["e" /* moveArticleToTop */](article, sourceIndex));
    }
  }, {
    key: "renderBreadcrumbs",
    value: function renderBreadcrumbs() {
      var _this$props6 = this.props,
          breadcrumbs = _this$props6.breadcrumbs,
          isFetching = _this$props6.isFetching;

      if (isFetching) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_components_lib_Breadcrumbs___default.a, {
        breadcrumbs: breadcrumbs,
        onBreadcrumbClick: this.onBreadcrumbClick
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props7 = this.props,
          articlePage = _this$props7.articlePage,
          sectionPage = _this$props7.sectionPage,
          articleCount = _this$props7.articleCount,
          sectionCount = _this$props7.sectionCount,
          isFetching = _this$props7.isFetching;

      if (isFetching) {
        return null;
      }

      if (sectionCount === 0 && articleCount === 0) {
        return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_26__Empty__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_26__Empty__["a" /* default */].Title, {}, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.section.empty")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_26__Empty__["a" /* default */].Description, {}, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.section.emptyDescription")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_26__Empty__["a" /* default */].Actions, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__zendeskgarden_react_buttons__["Button"], {
          size: "small",
          "data-test-id": "empty-add-section",
          onClick: this.openNewSectionPage
        }, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.sections.addSection")), _ref, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_18__zendeskgarden_react_buttons__["Button"], {
          primary: true,
          size: "small",
          "data-test-id": "empty-add-article",
          onClick: this.openNewArticlePage
        }, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.articles.addArticle"))));
      }

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_24__SectionList__["a" /* default */], {
        onMoveToTop: this.onSectionMoveToTop,
        onPageSelected: this.onSectionPageSelected,
        page: sectionPage,
        count: sectionCount
      }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_25__ArticleList__["a" /* default */], {
        onMoveToTop: this.onArticleMoveToTop,
        onPageSelected: this.onArticlePageSelected,
        page: articlePage,
        count: articleCount
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var hasCommunity = this.props.hasCommunity;
      var hc = Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getHelpCenter"])();
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a, {
        brandId: Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])(),
        dir: __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default.a.dir,
        topNav: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("a", {
          href: "/knowledge/arrange?brand_id=".concat(Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getCurrentBrandId"])())
        }, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.breadcrumbs.arrangeContent"))), _ref2, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendesk_knowledge_chrome_lib_Chrome___default.a.Breadcrumbs.Item, {}, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.name")))
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"].Item, {
        active: true,
        testId: "sidebar-user-segments-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.name")), hasCommunity && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: __WEBPACK_IMPORTED_MODULE_20__zendesk_knowledge_utils_lib_createBrandedUrl___default()(hc.route.subdomain, "/hc/admin/arrange_contents#community"),
        testId: "sidebar-arrange-topics-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.sidebar.arrangeTopics")), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["Sidebar"].LinkItem, {
        href: __WEBPACK_IMPORTED_MODULE_20__zendesk_knowledge_utils_lib_createBrandedUrl___default()(hc.route.subdomain, "/hc/admin/import_articles"),
        testId: "sidebar-import-articles-link"
      }, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.sidebar.importArticles"))), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendesk_guide_chrome__["ContentView"], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_22__ErrorBoundary__["a" /* default */], {}, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_27__Notifications__["a" /* default */], {
        dir: __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default.a.dir
      }), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.appHeader
      }, void 0, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()("h1", {
        className: __WEBPACK_IMPORTED_MODULE_29__index_css___default.a.title
      }, void 0, __WEBPACK_IMPORTED_MODULE_17__zendesk_client_i18n_tools___default()("knowledge-arrange.name"))), this.renderBreadcrumbs(), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_19_react_beautiful_dnd__["a" /* DragDropContext */], {
        onDragEnd: this.onDragEnd
      }, void 0, this.renderContent()), _ref3)));
    }
  }]);

  return Section;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
Section.propTypes = {
  dispatch: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  sectionId: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string.isRequired,
  isFetching: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool.isRequired,
  sectionCount: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  sectionPage: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  articleCount: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  articlePage: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  breadcrumbs: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string.isRequired
  })).isRequired,
  hasCommunity: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool
};

var mapStateToProps = function mapStateToProps(_ref4, _ref5) {
  var articles = _ref4.articles,
      section = _ref4.section,
      sections = _ref4.sections,
      overlay = _ref4.overlay;
  var match = _ref5.match;
  var sectionPage = parseInt(match.params.sectionPage, 10);
  var articlePage = parseInt(match.params.articlePage, 10);
  return {
    sectionId: match.params.id,
    isFetching: section.isFetching,
    articleCount: section.articleCount,
    sectionCount: section.sectionCount,
    breadcrumbs: section.breadcrumbs,
    sectionPage: isNaN(sectionPage) ? 1 : sectionPage,
    articlePage: isNaN(articlePage) ? 1 : articlePage,
    hasCommunity: Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["hasFeature"])("community") && Object(__WEBPACK_IMPORTED_MODULE_14__zendesk_knowledge_context__["getHelpCenter"])().community
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(mapStateToProps)(Section));

/***/ }),

/***/ 733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ArticleList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_pagination__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_beautiful_dnd__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ArticleRow__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_section__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__index_css__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__index_css__);

















var ArticleList =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ArticleList, _Component);

  function ArticleList(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ArticleList);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ArticleList).call(this, props));
    _this.onArticleMoveTo = _this.onArticleMoveTo.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ArticleList, [{
    key: "onArticleMoveTo",
    value: function onArticleMoveTo(articleId, destinationOption, sourceIndex) {
      var dispatch = this.props.dispatch;
      var destinationOptionId = destinationOption.id,
          destinationOptionType = destinationOption.type;
      destinationOptionType === "Section" && dispatch(__WEBPACK_IMPORTED_MODULE_15__actions_section__["d" /* moveArticleToSection */](articleId, destinationOptionId, sourceIndex));
    }
  }, {
    key: "renderArticles",
    value: function renderArticles() {
      var _this2 = this;

      var _this$props = this.props,
          articles = _this$props.articles,
          isFetching = _this$props.isFetching,
          pageCount = _this$props.pageCount,
          page = _this$props.page,
          onPageSelected = _this$props.onPageSelected,
          isMoving = _this$props.isMoving,
          articleSavingId = _this$props.articleSavingId,
          articleSuccessId = _this$props.articleSuccessId,
          _onMoveToTop = _this$props.onMoveToTop;

      if (isFetching) {
        return null;
      }

      var pagination = pageCount > 1 && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        "data-test-id": "articles-pagination"
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_pagination__["Pagination"], {
        totalPages: pageCount,
        currentPage: page,
        onChange: onPageSelected
      }));

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_16__index_css___default.a.list
      }, void 0, articles.map(function (article, index) {
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13_react_beautiful_dnd__["b" /* Draggable */], {
          draggableId: article.id,
          index: index,
          type: "article",
          isDragDisabled: isMoving
        }, article.id, function (provided, snapshot) {
          return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__ArticleRow__["a" /* default */], {
            testId: "article-item",
            onMoveToTop: function onMoveToTop() {
              return _onMoveToTop(article, index);
            },
            saving: articleSavingId === article.id,
            success: articleSuccessId === article.id,
            article: article,
            dragging: snapshot.isDragging,
            dragHandleProps: provided.dragHandleProps,
            dragRef: provided.innerRef,
            dragProps: provided.draggableProps,
            onMoveTo: function onMoveTo(destinationSection) {
              return _this2.onArticleMoveTo(article.id, destinationSection, index);
            }
          }, article.id);
        });
      })), pagination);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var count = this.props.count;

      if (count === 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_16__index_css___default.a.container
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("h3", {
        className: __WEBPACK_IMPORTED_MODULE_16__index_css___default.a.listHeader
      }, void 0, __WEBPACK_IMPORTED_MODULE_11__zendesk_client_i18n_tools___default()("knowledge-arrange.articles.pageTitle", {
        count: count
      })), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13_react_beautiful_dnd__["c" /* Droppable */], {
        droppableId: "articles",
        type: "article"
      }, void 0, function (provided, snapshot) {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          ref: provided.innerRef
        }, provided.droppableProps), _this3.renderArticles());
      }));
    }
  }]);

  return ArticleList;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
ArticleList.propTypes = {
  articles: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string.isRequired,
    html_url: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].string.isRequired
  })).isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func.isRequired,
  count: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  isFetching: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool.isRequired,
  isMoving: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].bool.isRequired,
  pageCount: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  page: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number.isRequired,
  onPageSelected: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func,
  articleSavingId: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number,
  articleSuccessId: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].number,
  onMoveToTop: __WEBPACK_IMPORTED_MODULE_9_prop_types__["PropTypes"].func
};

var mapStateToProps = function mapStateToProps(_ref) {
  var articles = _ref.articles;
  return {
    articles: articles.list,
    isFetching: articles.isFetching,
    pageCount: articles.pageCount,
    isMoving: articles.isMoving,
    articleSavingId: articles.savingId,
    articleSuccessId: articles.successId
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(mapStateToProps)(ArticleList));

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArticleRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_tags__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_loaders__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_loaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_loaders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_context__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MoveToModal__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__index_css__);













var _ref5 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("g", {
  fill: "currentColor"
}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "7",
  cy: "13",
  r: "2"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "13",
  cy: "13",
  r: "2"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("circle", {
  cx: "19",
  cy: "13",
  r: "2"
}));

var EllipsisIcon = function EllipsisIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("svg", props, _ref5);
};

EllipsisIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  viewBox: "0 0 26 26"
};

var _ref6 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("g", {
  fill: "currentColor"
}, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "1",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "1",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "5",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "5",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "3",
  y: "9",
  rx: ".5",
  ry: ".5"
}), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("rect", {
  width: "2",
  height: "2",
  x: "7",
  y: "9",
  rx: ".5",
  ry: ".5"
}));

var GripIcon = function GripIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("svg", props, _ref6);
};

GripIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
};

var _ref7 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("path", {
  fill: "currentColor",
  d: "M2.88 11.73c-.19 0-.39-.06-.55-.18a.938.938 0 0 1-.37-1.01l.8-3L.35 5.57a.938.938 0 0 1-.3-1.03c.12-.37.45-.63.85-.65L4 3.73 5.12.83c.14-.37.49-.61.88-.61s.74.24.88.6L8 3.73l3.11.17a.946.946 0 0 1 .55 1.68L9.24 7.53l.8 3a.95.95 0 0 1-1.43 1.04L6 9.88l-2.61 1.69c-.16.1-.34.16-.51.16z"
});

var StarIcon = function StarIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("svg", props, _ref7);
};

StarIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
};








var _ref2 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(EllipsisIcon, {});

var _ref3 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(GripIcon, {});

var _ref4 =
/*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__zendeskgarden_react_loaders__["Spinner"], {
  delayMs: 0
});

var ArticleRow =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(ArticleRow, _Component);

  function ArticleRow(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, ArticleRow);

    _this = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(ArticleRow).call(this, props));
    _this.state = {
      isMoveToModalVisible: false
    };
    _this.onMoveToTop = _this.onMoveToTop.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onEditClick = _this.onEditClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onViewClick = _this.onViewClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onMoveToClick = _this.onMoveToClick.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    _this.onModalClose = _this.onModalClose.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this)));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(ArticleRow, [{
    key: "onMoveToTop",
    value: function onMoveToTop(e) {
      e.stopPropagation();
      var onMoveToTop = this.props.onMoveToTop;
      onMoveToTop();
    }
  }, {
    key: "onEditClick",
    value: function onEditClick(e) {
      e.stopPropagation();
      var article = this.props.article;
      window.open("/knowledge/articles/".concat(article.id, "/edit?brand_id=").concat(Object(__WEBPACK_IMPORTED_MODULE_16__zendesk_knowledge_context__["getCurrentBrandId"])()), "_blank");
    }
  }, {
    key: "onViewClick",
    value: function onViewClick(e) {
      e.stopPropagation();
      var article = this.props.article;
      window.open(article.html_url, "_blank");
    }
  }, {
    key: "onMoveToClick",
    value: function onMoveToClick(e) {
      e.stopPropagation();
      this.setState({
        isMoveToModalVisible: true
      });
    }
  }, {
    key: "onModalClose",
    value: function onModalClose() {
      this.setState({
        isMoveToModalVisible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2;

      var _this$props = this.props,
          article = _this$props.article,
          testId = _this$props.testId,
          dragHandleProps = _this$props.dragHandleProps,
          dragRef = _this$props.dragRef,
          dragProps = _this$props.dragProps,
          saving = _this$props.saving,
          success = _this$props.success,
          dragging = _this$props.dragging,
          onMoveTo = _this$props.onMoveTo;
      var isMoveToModalVisible = this.state.isMoveToModalVisible;

      var menu = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__["Menu"], {
        "data-test-id": testId && "".concat(testId, "-menu"),
        trigger: function trigger(_ref) {
          var ref = _ref.ref,
              isOpen = _ref.isOpen;
          return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("a", {
            ref: ref,
            "aria-label": __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.section.menuAriaLabel"),
            tabIndex: 0,
            className: __WEBPACK_IMPORTED_MODULE_14_classnames___default()(__WEBPACK_IMPORTED_MODULE_18__index_css___default.a.trigger, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.open, isOpen)),
            "data-test-id": testId && "".concat(testId, "-menu-trigger")
          }, _ref2);
        }
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-edit"),
        onClick: this.onEditClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.article.edit")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-move-to"),
        onClick: this.onMoveToClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.moveTo.menuItem")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-move-to-top"),
        onClick: this.onMoveToTop
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.article.sendToTop")), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__zendeskgarden_react_menus__["Item"], {
        "data-test-id": testId && "".concat(testId, "-view"),
        onClick: this.onViewClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_15__zendesk_client_i18n_tools___default()("knowledge-arrange.article.view")));

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        className: __WEBPACK_IMPORTED_MODULE_14_classnames___default()(__WEBPACK_IMPORTED_MODULE_18__index_css___default.a.row, (_classnames2 = {}, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.dragging, dragging), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.saving, saving), __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(_classnames2, __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.success, success), _classnames2)),
        "data-test-id": testId && "".concat(testId, "-row"),
        ref: dragRef
      }, dragProps), isMoveToModalVisible && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17__MoveToModal__["a" /* default */], {
        onMove: onMoveTo,
        onClose: this.onModalClose,
        name: article.title,
        destinationTypes: ["Section"]
      }), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        role: "button",
        tabIndex: 0,
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.grip,
        "data-test-id": testId && "".concat(testId, "-drag-handle")
      }, dragHandleProps), _ref3), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.content
      }, void 0, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.name,
        "data-test-id": testId && "".concat(testId, "-name")
      }, void 0, article.title), article.promoted && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(StarIcon, {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.promoted
      }), article.user_segment && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__zendeskgarden_react_tags__["Tag"], {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.userSegment,
        type: "blue"
      }, void 0, article.user_segment.name)), saving ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_jsx___default()("div", {
        className: __WEBPACK_IMPORTED_MODULE_18__index_css___default.a.loader
      }, void 0, _ref4) : menu);
    }
  }]);

  return ArticleRow;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);


ArticleRow.propTypes = {
  article: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].shape({
    id: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].number.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired,
    user_segment: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].shape({
      name: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired
    }),
    promoted: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
    html_url: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string.isRequired
  }).isRequired,
  testId: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].string,
  dragHandleProps: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].object,
  dragProps: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].object,
  dragRef: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func,
  saving: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  success: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  dragging: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].bool,
  onMoveTo: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func.isRequired,
  onMoveToTop: __WEBPACK_IMPORTED_MODULE_10_prop_types__["PropTypes"].func.isRequired
};

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"_-src-components-ArticleRow-index---row---127qS","name":"_-src-components-ArticleRow-index---name---fwU2-","saving":"_-src-components-ArticleRow-index---saving---3PTXw","loader":"_-src-components-ArticleRow-index---loader---3cN-N","trigger":"_-src-components-ArticleRow-index---trigger---2SQNd","open":"_-src-components-ArticleRow-index---open---bfdxt","content":"_-src-components-ArticleRow-index---content---1hEwc","promoted":"_-src-components-ArticleRow-index---promoted---1Fo4Q","userSegment":"_-src-components-ArticleRow-index---userSegment---1C6Zf","success":"_-src-components-ArticleRow-index---success---2Uoju","dragging":"_-src-components-ArticleRow-index---dragging---1gCVY","grip":"_-src-components-ArticleRow-index---grip---3UMod"};

/***/ }),

/***/ 737:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"appTitle":"_-src-components-ArticleList-index---appTitle---1kQJd","loader":"_-src-components-ArticleList-index---loader---3wcFr","list":"_-src-components-ArticleList-index---list---dxbBH","container":"_-src-components-ArticleList-index---container---3z12o","listHeader":"_-src-components-ArticleList-index---listHeader---2BNHp"};

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"appHeader":"_-src-components-Section-index---appHeader---15Y7y","title":"_-src-components-Section-index---title---30JKI","loader":"_-src-components-Section-index---loader---1_ftm"};

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isMovingDown;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeItemPosition;
/* harmony export (immutable) */ __webpack_exports__["b"] = getItemAbove;
/* harmony export (immutable) */ __webpack_exports__["c"] = getItemBelow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);

function isMovingDown(sourceIndex, destinationIndex) {
  return sourceIndex < destinationIndex;
}
function changeItemPosition(arr, sourceIndex, destinationIndex) {
  var newArr = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(arr);

  var item = newArr[sourceIndex];
  var movingDown = isMovingDown(sourceIndex, destinationIndex);
  newArr.splice(movingDown ? destinationIndex + 1 : destinationIndex, 0, item);
  var removeIndex = movingDown ? sourceIndex : sourceIndex + 1;
  newArr.splice(removeIndex, 1);
  return newArr;
}
function getItemAbove(arr, sourceIndex, destinationIndex) {
  if (destinationIndex === 0) {
    return null;
  }

  if (isMovingDown(sourceIndex, destinationIndex)) {
    return arr[destinationIndex];
  }

  return arr[destinationIndex - 1];
}
function getItemBelow(arr, sourceIndex, destinationIndex) {
  if (destinationIndex === arr.length - 1) {
    return null;
  }

  if (isMovingDown(sourceIndex, destinationIndex)) {
    return arr[destinationIndex + 1];
  }

  return arr[destinationIndex];
}

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(51)
  , core      = __webpack_require__(52)
  , ctx       = __webpack_require__(272)
  , hide      = __webpack_require__(76)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(77)
  , createDesc = __webpack_require__(129);
module.exports = __webpack_require__(78) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_redux_lib_reducers_notifications__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_redux_lib_reducers_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_redux_lib_reducers_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__categories__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sections__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__section__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__articles__ = __webpack_require__(766);








/* harmony default export */ __webpack_exports__["a"] = (function (history) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
    router: Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["connectRouter"])(history),
    categories: __WEBPACK_IMPORTED_MODULE_3__categories__["a" /* default */],
    sections: __WEBPACK_IMPORTED_MODULE_5__sections__["a" /* default */],
    category: __WEBPACK_IMPORTED_MODULE_4__category__["a" /* default */],
    section: __WEBPACK_IMPORTED_MODULE_6__section__["a" /* default */],
    articles: __WEBPACK_IMPORTED_MODULE_7__articles__["a" /* default */],
    notifications: __WEBPACK_IMPORTED_MODULE_2__zendesk_knowledge_redux_lib_reducers_notifications___default.a
  });
});

/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = categories;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_positioning__ = __webpack_require__(74);



var initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  list: [],
  page: 0,
  pageCount: 0,
  count: 0,
  isMoving: false,
  savingId: null,
  successId: null
};
function categories() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["b" /* FETCH_CATEGORIES_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["c" /* FETCH_CATEGORIES_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: true,
          list: action.categories,
          page: action.page,
          pageCount: action.pageCount,
          count: action.count
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["a" /* FETCH_CATEGORIES_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["h" /* POSITION_CATEGORY_REQUEST */]:
      {
        return Object.assign({}, state, {
          isMoving: true,
          savingId: state.list[action.sourceIndex].id,
          successId: null,
          list: Object(__WEBPACK_IMPORTED_MODULE_2__utils_positioning__["a" /* changeItemPosition */])(state.list, action.sourceIndex, action.destinationIndex)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["g" /* POSITION_CATEGORY_FAILURE */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: null,
          list: Object(__WEBPACK_IMPORTED_MODULE_2__utils_positioning__["a" /* changeItemPosition */])(state.list, action.destinationIndex, action.sourceIndex)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["i" /* POSITION_CATEGORY_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: state.savingId
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["e" /* MOVE_CATEGORY_TO_TOP_REQUEST */]:
      {
        var item = state.list[action.sourceIndex];
        return Object.assign({}, state, {
          isMoving: true,
          savingId: item.id,
          successId: null,
          list: state.page === 1 ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_positioning__["a" /* changeItemPosition */])(state.list, action.sourceIndex, 0) : state.list.filter(function (category) {
            return category.id !== item.id;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["d" /* MOVE_CATEGORY_TO_TOP_FAILURE */]:
      {
        var newList;

        if (state.page === 1) {
          newList = Object(__WEBPACK_IMPORTED_MODULE_2__utils_positioning__["a" /* changeItemPosition */])(state.list, 0, action.sourceIndex);
        } else {
          newList = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.list);
          newList.splice(action.sourceIndex, 0, action.item);
        }

        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: null,
          list: newList
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_categories_types__["f" /* MOVE_CATEGORY_TO_TOP_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: state.savingId
        });
      }

    default:
      return state;
  }
}

/***/ }),

/***/ 763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = category;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_category_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_section_types__ = __webpack_require__(99);


var initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  id: null,
  name: null,
  sectionCount: 0,
  breadcrumbs: []
};
function category() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_category_types__["b" /* FETCH_CATEGORY_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_category_types__["f" /* FETCH_CATEGORY_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: true,
          id: action.category.id,
          name: action.category.name,
          sectionCount: action.category.section_count,
          breadcrumbs: action.category.breadcrumbs
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_category_types__["a" /* FETCH_CATEGORY_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["t" /* MOVE_SECTION_TO_SECTION_REQUEST */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          sectionCount: state.sectionCount - 1
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["s" /* MOVE_SECTION_TO_SECTION_FAILURE */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          sectionCount: state.sectionCount + 1
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["q" /* MOVE_SECTION_TO_CATEGORY_REQUEST */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          sectionCount: state.sectionCount - 1
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["p" /* MOVE_SECTION_TO_CATEGORY_FAILURE */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          sectionCount: state.sectionCount + 1
        });
      }

    default:
      return state;
  }
}

/***/ }),

/***/ 764:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sections;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_category_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_section_types__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_positioning__ = __webpack_require__(74);




var initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  isMoving: false,
  list: [],
  page: 0,
  pageCount: 0,
  count: 0,
  savingId: null,
  successId: null
};
function sections() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["g" /* FETCH_SECTION_SECTIONS_REQUEST */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["d" /* FETCH_CATEGORY_SECTIONS_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["h" /* FETCH_SECTION_SECTIONS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["e" /* FETCH_CATEGORY_SECTIONS_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: true,
          list: action.sections,
          page: action.page,
          pageCount: action.pageCount,
          count: action.count
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["f" /* FETCH_SECTION_SECTIONS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["c" /* FETCH_CATEGORY_SECTIONS_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["j" /* MOVE_ARTICLE_TO_SECTION_FAILURE */]:
      {
        return Object.assign({}, state, {
          savingId: null,
          list: state.list.map(function (section) {
            if (section.id === action.destinationSectionId) {
              return Object.assign({}, section, {
                article_count: section.article_count - 1
              });
            }

            return section;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["k" /* MOVE_ARTICLE_TO_SECTION_REQUEST */]:
      {
        return Object.assign({}, state, {
          savingId: action.destinationSectionId,
          list: state.list.map(function (section) {
            if (section.id === action.destinationSectionId) {
              return Object.assign({}, section, {
                article_count: section.article_count + 1
              });
            }

            return section;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["l" /* MOVE_ARTICLE_TO_SECTION_SUCCESS */]:
      {
        return Object.assign({}, state, {
          savingId: null,
          successId: action.destinationSectionId
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["k" /* POSITION_CATEGORY_SECTION_REQUEST */]:
    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["C" /* POSITION_SECTION_REQUEST */]:
      {
        return Object.assign({}, state, {
          isMoving: true,
          savingId: state.list[action.sourceIndex].id,
          successId: null,
          list: Object(__WEBPACK_IMPORTED_MODULE_3__utils_positioning__["a" /* changeItemPosition */])(state.list, action.sourceIndex, action.destinationIndex)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["j" /* POSITION_CATEGORY_SECTION_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["B" /* POSITION_SECTION_FAILURE */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: null,
          list: Object(__WEBPACK_IMPORTED_MODULE_3__utils_positioning__["a" /* changeItemPosition */])(state.list, action.destinationIndex, action.sourceIndex)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["l" /* POSITION_CATEGORY_SECTION_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["D" /* POSITION_SECTION_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: state.savingId
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["t" /* MOVE_SECTION_TO_SECTION_REQUEST */]:
      {
        return Object.assign({}, state, {
          isMoving: true,
          savingId: action.destinationSectionId,
          successId: null,
          list: state.list.filter(function (_ref) {
            var id = _ref.id;
            return id !== action.movedSectionId;
          }).map(function (section) {
            if (section.id === action.destinationSectionId) {
              return Object.assign({}, section, {
                section_count: section.section_count + 1
              });
            }

            return section;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["u" /* MOVE_SECTION_TO_SECTION_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: action.destinationSectionId
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["s" /* MOVE_SECTION_TO_SECTION_FAILURE */]:
      {
        var newList = state.list.map(function (section) {
          if (section.id === action.destinationSectionId) {
            return Object.assign({}, section, {
              section_count: section.section_count - 1
            });
          }

          return section;
        });
        newList.splice(action.sourceIndex, 0, action.item);
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          list: newList
        });
      }

    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["q" /* MOVE_SECTION_TO_CATEGORY_REQUEST */]:
      {
        return Object.assign({}, state, {
          list: state.list.filter(function (_ref2) {
            var id = _ref2.id;
            return id !== action.movedSectionId;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["h" /* MOVE_CATEGORY_SECTION_TO_TOP_REQUEST */]:
    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["w" /* MOVE_SECTION_TO_TOP_REQUEST */]:
      {
        var item = state.list[action.sourceIndex];
        return Object.assign({}, state, {
          isMoving: true,
          savingId: item.id,
          successId: null,
          list: state.page === 1 ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_positioning__["a" /* changeItemPosition */])(state.list, action.sourceIndex, 0) : state.list.filter(function (section) {
            return section.id !== item.id;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["g" /* MOVE_CATEGORY_SECTION_TO_TOP_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["v" /* MOVE_SECTION_TO_TOP_FAILURE */]:
      {
        var _newList;

        if (state.page === 1) {
          _newList = Object(__WEBPACK_IMPORTED_MODULE_3__utils_positioning__["a" /* changeItemPosition */])(state.list, 0, action.sourceIndex);
        } else {
          _newList = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.list);

          _newList.splice(action.sourceIndex, 0, action.item);
        }

        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: null,
          list: _newList
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_category_types__["i" /* MOVE_CATEGORY_SECTION_TO_TOP_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__actions_section_types__["x" /* MOVE_SECTION_TO_TOP_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: state.savingId
        });
      }

    default:
      return state;
  }
}

/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = section;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_section_types__ = __webpack_require__(99);

var initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  id: null,
  name: null,
  sectionCount: 0,
  articleCount: 0,
  breadcrumbs: []
};
function section() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["e" /* FETCH_SECTION_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["i" /* FETCH_SECTION_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: true,
          id: action.section.id,
          name: action.section.name,
          sectionCount: action.section.section_count,
          articleCount: action.section.article_count,
          breadcrumbs: action.section.breadcrumbs
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["d" /* FETCH_SECTION_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["t" /* MOVE_SECTION_TO_SECTION_REQUEST */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          sectionCount: state.sectionCount - 1
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["s" /* MOVE_SECTION_TO_SECTION_FAILURE */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          sectionCount: state.sectionCount + 1
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["q" /* MOVE_SECTION_TO_CATEGORY_REQUEST */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          sectionCount: state.sectionCount - 1
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["p" /* MOVE_SECTION_TO_CATEGORY_FAILURE */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          sectionCount: state.sectionCount + 1
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["k" /* MOVE_ARTICLE_TO_SECTION_REQUEST */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          articleCount: state.articleCount - 1
        });
      }

    case __WEBPACK_IMPORTED_MODULE_0__actions_section_types__["j" /* MOVE_ARTICLE_TO_SECTION_FAILURE */]:
      {
        if (!state.isLoaded) {
          return state;
        }

        return Object.assign({}, state, {
          articleCount: state.articleCount + 1
        });
      }

    default:
      return state;
  }
}

/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = articles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_section_types__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_positioning__ = __webpack_require__(74);



var initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  isMoving: false,
  list: [],
  page: 0,
  pageCount: 0,
  count: 0,
  savingId: null,
  successId: null
};
function articles() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["b" /* FETCH_SECTION_ARTICLES_REQUEST */]:
      {
        return Object.assign({}, state, {
          isFetching: true,
          hasFetchError: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["c" /* FETCH_SECTION_ARTICLES_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          hasFetchError: false,
          isLoaded: true,
          list: action.articles,
          page: action.page,
          pageCount: action.pageCount,
          count: action.count
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["a" /* FETCH_SECTION_ARTICLES_FAILURE */]:
      {
        return Object.assign({}, state, {
          isFetching: false,
          isLoaded: false,
          hasFetchError: true
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["k" /* MOVE_ARTICLE_TO_SECTION_REQUEST */]:
      {
        return Object.assign({}, state, {
          isMoving: true,
          list: state.list.filter(function (_ref) {
            var id = _ref.id;
            return id !== action.movedArticleId;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["j" /* MOVE_ARTICLE_TO_SECTION_FAILURE */]:
      {
        var newList = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.list);

        newList.splice(action.sourceIndex, 0, action.item);
        return Object.assign({}, state, {
          isMoving: false,
          list: newList
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["l" /* MOVE_ARTICLE_TO_SECTION_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isMoving: false
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["z" /* POSITION_ARTICLE_REQUEST */]:
      {
        return Object.assign({}, state, {
          isMoving: true,
          savingId: state.list[action.sourceIndex].id,
          successId: null,
          list: Object(__WEBPACK_IMPORTED_MODULE_2__utils_positioning__["a" /* changeItemPosition */])(state.list, action.sourceIndex, action.destinationIndex)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["y" /* POSITION_ARTICLE_FAILURE */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: null,
          list: Object(__WEBPACK_IMPORTED_MODULE_2__utils_positioning__["a" /* changeItemPosition */])(state.list, action.destinationIndex, action.sourceIndex)
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["A" /* POSITION_ARTICLE_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: state.savingId
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["n" /* MOVE_ARTICLE_TO_TOP_REQUEST */]:
      {
        var item = state.list[action.sourceIndex];
        return Object.assign({}, state, {
          isMoving: true,
          savingId: item.id,
          successId: null,
          list: state.page === 1 ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_positioning__["a" /* changeItemPosition */])(state.list, action.sourceIndex, 0) : state.list.filter(function (article) {
            return article.id !== item.id;
          })
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["m" /* MOVE_ARTICLE_TO_TOP_FAILURE */]:
      {
        var _newList;

        if (state.page === 1) {
          _newList = Object(__WEBPACK_IMPORTED_MODULE_2__utils_positioning__["a" /* changeItemPosition */])(state.list, 0, action.sourceIndex);
        } else {
          _newList = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.list);

          _newList.splice(action.sourceIndex, 0, action.item);
        }

        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: null,
          list: _newList
        });
      }

    case __WEBPACK_IMPORTED_MODULE_1__actions_section_types__["o" /* MOVE_ARTICLE_TO_TOP_SUCCESS */]:
      {
        return Object.assign({}, state, {
          isMoving: false,
          savingId: null,
          successId: state.savingId
        });
      }

    default:
      return state;
  }
}

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(100)
  , IE8_DOM_DEFINE = __webpack_require__(273)
  , toPrimitive    = __webpack_require__(180)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(78) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(79)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(275)
  , enumBugKeys = __webpack_require__(185);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(184)('wks')
  , uid        = __webpack_require__(130)
  , Symbol     = __webpack_require__(51).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_SECTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_SECTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_SECTION_SECTIONS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_SECTION_SECTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SECTION_SECTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_SECTION_ARTICLES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SECTION_ARTICLES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SECTION_ARTICLES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MOVE_ARTICLE_TO_SECTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MOVE_ARTICLE_TO_SECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MOVE_ARTICLE_TO_SECTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return POSITION_ARTICLE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return POSITION_ARTICLE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return POSITION_ARTICLE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return POSITION_SECTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return POSITION_SECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return POSITION_SECTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MOVE_SECTION_TO_SECTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MOVE_SECTION_TO_SECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MOVE_SECTION_TO_SECTION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MOVE_SECTION_TO_CATEGORY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MOVE_SECTION_TO_CATEGORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MOVE_SECTION_TO_CATEGORY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MOVE_SECTION_TO_TOP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MOVE_SECTION_TO_TOP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MOVE_SECTION_TO_TOP_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MOVE_ARTICLE_TO_TOP_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MOVE_ARTICLE_TO_TOP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MOVE_ARTICLE_TO_TOP_FAILURE; });
var FETCH_SECTION_REQUEST = "FETCH_SECTION_REQUEST";
var FETCH_SECTION_SUCCESS = "FETCH_SECTION_SUCCESS";
var FETCH_SECTION_FAILURE = "FETCH_SECTION_FAILURE";
var FETCH_SECTION_SECTIONS_REQUEST = "FETCH_SECTION_SECTIONS_REQUEST";
var FETCH_SECTION_SECTIONS_SUCCESS = "FETCH_SECTION_SECTIONS_SUCCESS";
var FETCH_SECTION_SECTIONS_FAILURE = "FETCH_SECTION_SECTIONS_FAILURE";
var FETCH_SECTION_ARTICLES_REQUEST = "FETCH_SECTION_ARTICLES_REQUEST";
var FETCH_SECTION_ARTICLES_SUCCESS = "FETCH_SECTION_ARTICLES_SUCCESS";
var FETCH_SECTION_ARTICLES_FAILURE = "FETCH_SECTION_ARTICLES_FAILURE";
var MOVE_ARTICLE_TO_SECTION_REQUEST = "MOVE_ARTICLE_TO_SECTION_REQUEST";
var MOVE_ARTICLE_TO_SECTION_SUCCESS = "MOVE_ARTICLE_TO_SECTION_SUCCESS";
var MOVE_ARTICLE_TO_SECTION_FAILURE = "MOVE_ARTICLE_TO_SECTION_FAILURE";
var POSITION_ARTICLE_REQUEST = "POSITION_ARTICLE_REQUEST";
var POSITION_ARTICLE_SUCCESS = "POSITION_ARTICLE_SUCCESS";
var POSITION_ARTICLE_FAILURE = "POSITION_ARTICLE_FAILURE";
var POSITION_SECTION_REQUEST = "POSITION_SECTION_REQUEST";
var POSITION_SECTION_SUCCESS = "POSITION_SECTION_SUCCESS";
var POSITION_SECTION_FAILURE = "POSITION_SECTION_FAILURE";
var MOVE_SECTION_TO_SECTION_REQUEST = "MOVE_SECTION_TO_SECTION_REQUEST";
var MOVE_SECTION_TO_SECTION_SUCCESS = "MOVE_SECTION_TO_SECTION_SUCCESS";
var MOVE_SECTION_TO_SECTION_FAILURE = "MOVE_SECTION_TO_SECTION_FAILURE";
var MOVE_SECTION_TO_CATEGORY_REQUEST = "MOVE_SECTION_TO_CATEGORY_REQUEST";
var MOVE_SECTION_TO_CATEGORY_SUCCESS = "MOVE_SECTION_TO_CATEGORY_SUCCESS";
var MOVE_SECTION_TO_CATEGORY_FAILURE = "MOVE_SECTION_TO_CATEGORY_FAILURE";
var MOVE_SECTION_TO_TOP_REQUEST = "MOVE_SECTION_TO_TOP_REQUEST";
var MOVE_SECTION_TO_TOP_SUCCESS = "MOVE_SECTION_TO_TOP_SUCCESS";
var MOVE_SECTION_TO_TOP_FAILURE = "MOVE_SECTION_TO_TOP_FAILURE";
var MOVE_ARTICLE_TO_TOP_REQUEST = "MOVE_ARTICLE_TO_TOP_REQUEST";
var MOVE_ARTICLE_TO_TOP_SUCCESS = "MOVE_ARTICLE_TO_TOP_SUCCESS";
var MOVE_ARTICLE_TO_TOP_FAILURE = "MOVE_ARTICLE_TO_TOP_FAILURE";

/***/ })

},[290]);


// WEBPACK FOOTER //
// app-0d922c18166b5725aaad.v2.js